//jshint ignore:start
(function () {
    'use strict';
    //Polyfill
    if (!Array.prototype.findIndex) {
        Array.prototype.findIndex = function (predicate) {
            if (this === null) {
                throw new TypeError('Array.prototype.findIndex called on null or undefined');
            }
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            var list = Object(this);
            var length = list.length >>> 0;
            var thisArg = arguments[1];
            var value;

            for (var i = 0; i < length; i++) {
                value = list[i];
                if (predicate.call(thisArg, value, i, list)) {
                    return i;
                }
            }
            return -1;
        };
    }

    if (!Array.prototype.find) {
        Array.prototype.find = function (predicate) {
            'use strict';
            if (this == null) {
                throw new TypeError('Array.prototype.find called on null or undefined');
            }
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            var list = Object(this);
            var length = list.length >>> 0;
            var thisArg = arguments[1];
            var value;

            for (var i = 0; i < length; i++) {
                value = list[i];
                if (predicate.call(thisArg, value, i, list)) {
                    return value;
                }
            }
            return undefined;
        };
    }
    if (!Array.prototype.forEach) {
        Array.prototype.forEach = function forEach(callback, thisArg) {
            'use strict';
            var T, k;
            if (this == null) {
                throw new TypeError('this is null or not defined');
            }
            var kValue,
                O = Object(this),
                len = O.length >>> 0;
            if ({}.toString.call(callback) !== '[object Function]') {
                throw new TypeError(callback + ' is not a function');
            }
            if (arguments.length >= 2) {
                T = thisArg;
            }
            k = 0;
            while (k < len) {
                if (k in O) {
                    kValue = O[k];
                    callback.call(T, kValue, k, O);
                }
                k++;
            }
        };
    }
    if (!Array.prototype.filter) {
        Array.prototype.filter = function (fun /*, thisArg*/) {
            'use strict';

            if (this === void 0 || this === null) {
                throw new TypeError();
            }

            var t = Object(this);
            var len = t.length >>> 0;
            if (typeof fun !== 'function') {
                throw new TypeError();
            }

            var res = [];
            var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
            for (var i = 0; i < len; i++) {
                if (i in t) {
                    var val = t[i];
                    if (fun.call(thisArg, val, i, t)) {
                        res.push(val);
                    }
                }
            }
            return res;
        };
    }

    if (!Array.prototype.map) {
        Array.prototype.map = function (callback, thisArg) {
            var T, A, k;

            if (this == null) {
                throw new TypeError(' this is null or not defined');
            }
            var O = Object(this);
            var len = O.length >>> 0;
            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }
            if (arguments.length > 1) {
                T = thisArg;
            }
            A = new Array(len);
            k = 0;
            while (k < len) {
                var kValue, mappedValue;
                if (k in O) {
                    kValue = O[k];
                    mappedValue = callback.call(T, kValue, k, O);
                    A[k] = mappedValue;
                }
                k++;
            }
            return A;
        };
    }
})();
(function () {
    'use strict';
    angular.module('imAnalytics', ['abAnalytics', 'hg.scrollStop']);
})();

(function () {
    'use strict';

    angular
        .module('imAnalytics')
        .service('imEventService', [
            'OBJECT',
            'DEBUG',
            'POPUP_VIEW',
            'PAGE_VIEW',
            'ANALYTICS_EVENT',
            'VIRTUAL_PAGE',
            '$window',
            '$http',
            'imCommonService',
            imEventService
        ]);

    function imEventService(OBJECT, DEBUG, POPUP_VIEW, PAGE_VIEW, ANALYTICS_EVENT, VIRTUAL_PAGE, $window, $http, imCommonService) {
        inditex.onReady(function () { });

        /*
        WideEyes
         */
        $window.imAnalytics = $window.imAnalytics || {};

        $window.imAnalytics.sendHit = function (object) {
            if (object && object.event === 'impression') {
                if (object.ecommerce) {
                    impression([], object);
                }
            } else {
                analyticsEvent([object]);
                if (object.eventData && object.eventData.action === 'ver_producto_cross') {
                    //window.sessionStorage.setItem('imList', 'productos_relacionados');
                }
            }
        };
        return {
            pageView: pageView,
            pageViewGA4: pageViewGA4,
            pageHitZenit: pageHitZenit,
            analyticsEvent: analyticsEvent,
            popupView: popupView,
            impression: impression,
            virtualPage: virtualPage
        };

        function pageView(data, ecommerce) {
            var dataLayer = { event: 'pageview' };

            dataLayer = validateArray(data, dataLayer);
            dataLayer = imCommonService.deepmerge(PAGE_VIEW, dataLayer);
            dataLayer = validateObject(dataLayer, ecommerce);
            sendDataLayer(dataLayer);
        }

        function pageViewGA4(data) {
            sendDataLayer(data);
        }

        function successCallback(_response) {
            // this callback will be called asynchronously
            // when the response is available
        }

        function errorCallback(_response) {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
        }

        function pageHitZenit(data) {
            $http.post('/integration/zenit/events/hit', data).then(successCallback, errorCallback);
        }

        function analyticsEvent(data, ecommerce) {
            var dataLayer = { event: 'analyticsEvent' };

            dataLayer = validateArray(data, dataLayer);
            dataLayer = imCommonService.deepmerge(ANALYTICS_EVENT, dataLayer);
            dataLayer = validateObject(dataLayer, ecommerce);
            sendDataLayer(dataLayer);
        }

        function popupView(data, ecommerce) {
            var dataLayer = { event: 'popupView' };

            dataLayer = validateArray(data, dataLayer);
            dataLayer = imCommonService.deepmerge(POPUP_VIEW, dataLayer);
            dataLayer = validateObject(dataLayer, ecommerce);
            sendDataLayer(dataLayer);
        }

        function impression(data, ecommerce) {
            var dataLayer = { event: 'impression' };
            dataLayer = validateArray(data, dataLayer);
            dataLayer = imCommonService.deepmerge(dataLayer, ecommerce);
            sendDataLayer(dataLayer);
        }

        function virtualPage(data, ecommerce) {
            var dataLayer = { event: 'virtualPage' };

            dataLayer = validateArray(data, dataLayer);
            dataLayer = imCommonService.deepmerge(VIRTUAL_PAGE, dataLayer);
            dataLayer = validateObject(dataLayer, ecommerce);
            sendDataLayer(dataLayer);
        }

        /**
         * PRIVATE FUNCTIONS
         */
        function parseJSON(k, v) {
            if (v === undefined) {
                return 'undefined';
            }
            return v;
        }

        function logEvent(datalayer) {
            var message = 'Send ' + datalayer.event;
            if (OBJECT) {
                DEBUG(message + '\n' + JSON.stringify(datalayer, parseJSON, 2));
            } else {
                DEBUG(message);
                DEBUG(datalayer);
            }
        }

        function validateArray(data, dataLayer) {
            if (Array.isArray(data)) {
                data.map(function (elementData) {
                    dataLayer = imCommonService.deepmerge(dataLayer, elementData);
                });
            } else {
                throw new TypeError('IM - attribute data must be an array');
            }

            return dataLayer;
        }

        function validateObject(dataLayer, objectData) {
            if (objectData && typeof objectData === 'object') {
                dataLayer = imCommonService.deepmerge(dataLayer, objectData);
            }

            return dataLayer;
        }

        function sendDataLayer(dataLayer) {
            logEvent(dataLayer);
            if (!$window.dataLayer) {
                $window.dataLayer = [];
            }
            $window.dataLayer.push(dataLayer);
        }
    }
})();

(function () {
    'use strict';
    angular.module('imAnalytics').service('imEventServiceWrapper', ['DEBUG', 'imEventService', 'imObjectData', imEventServiceWrapper]);

    function imEventServiceWrapper(DEBUG, imEventService, imObjectData) {
        return {
            sendBasicPageView: sendBasicPageView,
            sendBasicAnalytics: sendBasicAnalytics,
            sendServerError: sendServerError,
            sendFormError: sendFormError,
            sendCustomAnalytics: sendCustomAnalytics,
            sendServerUnidadeStock: sendServerUnidadeStock
        };

        function sendBasicPageView(section, pageType, pageTitle) {
            var dataObject = {
                context: imObjectData.getContextData(),
                page: imObjectData.getPageData(null, section, pageType, pageTitle),
                user: imObjectData.getUserData()
            };

            imEventService.pageView([dataObject]);
        }

        function sendBasicAnalytics(cf, category, action, label) {
            var dataObject = {
                eventData: imObjectData.getEventData(cf, category, action, label)
            };
            imEventService.analyticsEvent([dataObject]);
        }

        function sendCustomAnalytics(eventData, customData) {
            var dataObject = {
                eventData: eventData,
                customData: customData
            };
            imEventService.analyticsEvent([dataObject]);
        }

        function sendServerError(cf, category, form, error) {
            var dataObject = {
                eventData: imObjectData.getEventData(
                    cf,
                    category,
                    'error_servidor_' + (form.$name ? form.$name : 'default'),
                    errorCode(error.code, error.errorKey)
                )
            };
            imEventService.analyticsEvent([dataObject]);
        }

        function sendServerUnidadeStock(datosProducto, shopCart) {
            for (var i = 0; i < shopCart.items.length; i++) {
                if (datosProducto) {
                    if (shopCart.items[i].id === datosProducto[0].id) {
                        var nonStockProduct = shopCart.items[i];
                        i = shopCart.items.length;
                        var quantity = datosProducto[0].quantity;
                    }
                } else {
                    if (shopCart.items[i].availability !== 'in_stock' || shopCart.items[i].quantity > shopCart.items[i].unitsAvailable) {
                        var nonStockProduct = shopCart.items[i];
                        i = shopCart.items.length;
                        var quantity = nonStockProduct.quantity;
                    }
                }
            }

            var newEventData = 'checkout_cesta_error_error_servidor_unidadestock_implementacion_anlaitica';
            if (quantity && nonStockProduct) {
                newEventData = imObjectData.getEventData(
                    'checkout',
                    'cesta',
                    'error_servidor_unidadestock',
                    quantity + '_' + nonStockProduct.unitPrice / 100
                );
            }

            var newReference = null;
            if (nonStockProduct) {
                newReference = nonStockProduct.parentReference;
            }

            var dataObject = {
                eventData: newEventData,
                customData: {
                    product: {
                        reference: newReference
                    }
                }
            };

            var lastAnalyticsEventDataObject = getLastAnalyticsEventDataObject() || undefined;

            if (
                !lastAnalyticsEventDataObject ||
                dataObject.eventData.label !== lastAnalyticsEventDataObject.eventData.label ||
                dataObject.customData.product.reference !== lastAnalyticsEventDataObject.customData.product.reference
            ) {
                imEventService.analyticsEvent([dataObject]);
            }
        }

        function sendFormError(cf, category, form) {
            var action;
            action = 'error_' + form.$name;

            angular.forEach(form, function (value) {
                if (typeof value !== 'undefined' && value.hasOwnProperty('$modelValue') && value.$invalid) {
                    var dataObject = {
                        eventData: imObjectData.getEventData(cf, category, action, value.$name)
                    };
                    imEventService.analyticsEvent([dataObject]);
                }
            });
        }

        /**
         * PRIVATE
         */

        function errorCode(code, key) {
            return 'cod_' + (code ? code : '0') + '-desc_' + (key ? key : 'unknown');
        }

        function getLastAnalyticsEventDataObject() {
            var lastAnalyticsEventIndex = getLastAnalyticsEventHitIndex() || undefined;
            if (lastAnalyticsEventIndex) {
                var dataObject = {
                    eventData: dataLayer[lastAnalyticsEventIndex].eventData,
                    customData: {
                        product: {
                            reference: dataLayer[lastAnalyticsEventIndex].customData.product.reference
                        }
                    }
                };
                return dataObject;
            }
            return;
        }

        function getLastAnalyticsEventHitIndex() {
            for (var i = dataLayer.length - 1; i >= 0; i--) {
                if (/analyticsEvent/i.test(dataLayer[i].event)) {
                    return i;
                }
            }
        }
    }
})();

(function () {
    'use strict';
    angular.module('imAnalytics').service('imProductDataService', ['DEBUG', '$q', imProductDataService]);
    function imProductDataService(DEBUG, $q) {
        return {
            getSeason: getSeason,
            searchProductInCart: searchProductInCart,
            getStock: getStock,
            getPrice: getPrice,
            getXmedia: getXmedia,
            getIndexCart: getIndexCart,
            getProductInfo: getProductInfo,
            getProductInfoCart: getProductInfoCart,
            getBundleInfo: getBundleInfo,
            getLastSearchFromCookies: getLastSearchFromCookies,
            getPartNumberColor: getPartNumberColor
        };

        /**
         * Devuelve una promesa con los datos referentes a un producto.
         */

        /**
         * Para cuando hagan el cambio
         * function getProductDetail() {
         *  return $q(function(resolve) {
         *      resolve(inditex.iProductJSON)
         *  })
         * }
         *
         * Los mismo para los demás casos que existan, y sustituir joyr.x por la función
         */
        function getProductInfo(product, categoryId, color, sizeSku, colbenson) {
            var promise;
            //El producto en summary se envía cn la estructura de un shopcartItem
            if (!(product.maxPrice || product.minPrice) && !product.detail && !colbenson) {
                var productJson = getProductInfoCart(product);
                promise = function (resolve) {
                    resolve(productJson);
                };
                return $q(promise);
            }
            //var timeBefore = Date.now();
            //DEBUG(inditex.imCategory.visibleProducts.find(function(item){return item.id === product.id;}));
            //DEBUG(Date.now() - timeBefore);
            if (color === undefined || color === null) {
                color = inditex.iUrlJSON.params['colorId'];
            }

            var promises = [];
            //Si buscador y colbenson
            if (product.maxPrice || product.minPrice || colbenson) {
                var restEnabled = false;
                var prodId = product.id || product;
                inditex.getXconfiguracionValue('ANALYTICS_SEARCHENGINE_ENABLED', function (status, value) {
                    restEnabled = value === '1';
                });
                if (restEnabled) {
                    promises.push(joyr.rest.xRestGetProductDetail(prodId));
                } else {
                    var productInfo = {
                        id: prodId,
                        name: product.name
                    };
                    promise = function (resolve) {
                        resolve(productInfo);
                    };
                    return $q(promise);
                }
            }

            promise = function (resolve) {
                $q.all(promises).then(
                    function (data) {
                        var productData = data[0] || product;
                        var productDetail = productData.activeDetail || productData.detail;
                        var colorId = getColorId(productDetail.colors, color);
                        var sizeId = getSizeId(productDetail.colors, sizeSku, colorId);
                        var cat = getCategoryData(productData);
                        var xmedia = getXmedia(productDetail.xmedia);
                        var customization = isCustomizable(productData);
                        var productInfoObject = {
                            id: productDetail.reference,
                            key: productData.parentId || productData.id,
                            name: productData.nameEn || productData.name,
                            categoryInfo: {
                                categoryId: undefined,
                                category: undefined,
                                type: undefined,
                                productsNumber: undefined
                            },
                            categoryId: categoryId, //Deprecated
                            price: getPriceInColor(productDetail.colors, sizeSku, colorId),
                            color: colorId,
                            colorName: getColorName(productDetail.colors, color),
                            size: sizeId,
                            sizeName: getSizeName(productDetail.colors, sizeSku, colorId),
                            productState: getProductState(productDetail.colors, sizeSku),
                            claseProducto: getProductClass(productDetail.reference),
                            consumerProduct: undefined,
                            onlineOnly: undefined, // No es posible obtener productos, request fail
                            model: undefined, // colors.modelName
                            stock: getStockColor(productDetail.colors, colorId),
                            season: getSeason(productDetail.reference),
                            partNumberColor: getPartNumberColor(productDetail.reference, colorId),
                            partNumber: getPartNumber(productDetail.reference, colorId, sizeId),
                            section: cat.section,
                            family: cat.family,
                            subfamily: cat.subfamily,
                            category: cat.path,
                            dimension99: xmedia.model,
                            dimension100: xmedia.lightType,
                            dimension101: xmedia.background,
                            dimension117: xmedia.frame,
                            isRelated: productData.isRelated,
                            gridElemType: productData.gridElemType,
                            isCustomizable: customization
                        };
                        resolve(productInfoObject);
                    },
                    function (reason) {
                        DEBUG(reason);
                        resolve({});
                    }
                );
            };
            return $q(promise);
        }

        function getProductInfoCart(item, quantity) {
            var promise = function (resolve) {
                var cat = getCategoryData(item);
                var xmedia = getXmedia(item.xmedia);
                var customization = isCustomizable(item);
                var dimension156 = '';
                if (inditex.iUserJSON && inditex.iUserJSON.shopCart) {
                    dimension156 = inditex.iUserJSON.shopCart.id;
                }
                var productInfoObject = {
                    position: getIndexCart(item.parentId) || undefined,
                    quantity: quantity || item.quantity,
                    dimension96: item.colorId,
                    dimension97: getSizeId(item.colors, item.sku),
                    dimension99: xmedia.model,
                    dimension100: xmedia.lightType,
                    dimension101: xmedia.background,
                    dimension117: xmedia.frame,
                    dimension109: cat.section,
                    dimension111: cat.family,
                    dimension113: cat.subfamily,
                    dimension124: getModelName(item.colors, item.colorId),
                    dimension146: getLastSearchFromCookies(),
                    dimension156: dimension156,
                    category: cat.path,
                    name: item.nameEn || item.name,
                    id: item.parentReference,
                    key: item.parentId,
                    price: inditex.formatNumber(item.unitPrice),
                    partNumberColor: getPartNumberColor(item.parentReference, item.colorId),
                    partNumber: item.reference || getPartNumber(item.parentReference, item.colorId, getSizeId(item.colors, item.sku)),
                    productState: getProductStateCart(item),
                    claseProducto: getProductClass(item.parentReference),
                    isRelated: item.isRelated,
                    dimension29: customization
                };
                resolve(productInfoObject);
            };
            return $q(promise);
        }

        function getModelName(colorArray, colorId) {
            let modelName = '';

            if (colorArray && colorArray.length !== 0) {
                if (typeof colorId === 'number' && colorArray[colorId]) {
                    modelName = colorArray[colorId].modelName;
                } else if (typeof colorId === 'string') {
                    const colorIndex = colorArray.findIndex((color) => {
                        return color.id === colorId;
                    });
                    if (colorIndex && colorArray[colorIndex]) {
                        modelName = colorArray[colorIndex].modelName;
                    } else {
                        modelName = colorArray[0].modelName;
                    }
                } else {
                    modelName = colorArray[0].modelName;
                }
            }
            return modelName || undefined;
        }

        function getLastSearchFromCookies() {
            var result,
                cookie = '';

            if (window.localStorage) {
                cookie = JSON.parse(window.localStorage.getItem('ebx-session-query-history'));
            }
            if (cookie && cookie.value.length) {
                result = cookie.value[0];
            }

            return result;
        }

        function getBundleInfo(products) {
            var promises = products.bundleProductSummaries.map(function (product) {
                return getProductInfo(product);
            });
            var resolve = $q.all(promises).then(function (products) {
                return products;
            });
            return resolve;
        }

        /**
         * PRIVATE FUNCTIONS
         */

        function isCustomizable(productData) {
            if (productData.customization) {
                return 'si';
            }
            if (productData.state && productData.state.xcustomization) {
                return 'si';
            }
            return 'no';
        }

        function getXmedia(xmedia, colorId) {
            xmedia = xmedia || [];
            var obj = {
                model: undefined,
                frame: undefined,
                background: undefined,
                light: undefined
            };

            //xmediaItems de un producto por un color
            let index = -1;
            if (xmedia && xmedia.length) {
                index = xmedia.findIndex(function (item) {
                    return item.colorCode === colorId;
                });
            }
            if (index !== -1) {
                var xmediaItems = xmedia[index].xmediaItems;
                var extraInfo = [];

                for (var i = 0; i < xmediaItems.length; i++) {
                    obj.background = xmediaItems[i].set;
                    xmediaItems[i].medias.filter(function (elem) {
                        if (elem.clazz === 1) {
                            extraInfo.push(elem.extraInfo);
                        }
                    });
                }
                if (extraInfo.length > 0) {
                    obj.model = extraInfo[0].modelo;
                    obj.frame = extraInfo[0].plane;
                    obj.light = extraInfo[0].light;
                    obj.background = extraInfo[0].set;
                }
            }
            return obj;
        }

        function getCategoryData(product) {
            var p = product || {};
            var family = getFamily(p);
            var subfamily = getSubFamily(p);
            var section = getSection(p);
            return {
                path: section + '/' + family + '/' + subfamily,
                family: family,
                subfamily: subfamily,
                section: section
            };
        }

        function getFamily(product) {
            return product.family + '_' + product.familyNameEN;
        }

        function getSection(product) {
            return product.section + '_' + product.sectionNameEN;
        }
        function getSubFamily(product) {
            return product.subFamily + '_' + product.subFamilyNameEN;
        }

        function getPartNumberColor(reference, color) {
            color = color || '';
            // con el nuevo desarrollo de los Bundles hemos creado un activeDetail creo que el reference no se esta enviando correctamente
            reference = reference || '';
            var splitPartnumber = reference.split('-');
            return splitPartnumber.join(color + '-');
        }

        function getPartNumber(reference, color, size) {
            color = color || '';
            size = size || '';
            var splitPartnumber = reference.split('-');
            return splitPartnumber.join(color + size + '-');
        }

        function getPriceInColor(colorArray, sizeSku, colorId) {
            var price;
            if (colorArray && colorArray.length !== 0) {
                if (sizeSku) {
                    colorArray.map(function (color) {
                        var sizeIndex = color.sizes.findIndex(function (size) {
                            return size.sku === sizeSku;
                        });
                        if (sizeIndex !== -1) {
                            price = color.sizes[sizeIndex].price;
                        }
                    });
                } else if (colorId) {
                    var colorSelected = colorArray.find(function (color) {
                        return color.id === colorId;
                    });
                    price = colorSelected && colorSelected.sizes && colorSelected.sizes[0] ? colorSelected.sizes[0].price : undefined;
                } else {
                    price = colorArray[0].sizes[0] ? colorArray[0].sizes[0].price : undefined;
                }
            }
            var newPrice = parseInt(price);
            if (!isNaN(newPrice)) {
                newPrice = inditex.formatNumber(newPrice);
            } else {
                newPrice = inditex.formatNumber(price);
            }

            return newPrice;
        }
        function getProductStateCart(item) {
            return item.unitComparePrice ? 'saldo' : 'temporada';
        }

        function getProductState(colorArray, sizeSku) {
            var state;
            if (colorArray && colorArray.length !== 0) {
                if (sizeSku) {
                    colorArray.map(function (color) {
                        var sizeIndex = color.sizes.findIndex(function (size) {
                            return size.sku === sizeSku;
                        });
                        if (sizeIndex !== -1) {
                            state = color.sizes[sizeIndex].oldPrice ? 'saldo' : 'temporada';
                        }
                    });
                } else {
                    state = colorArray && colorArray[0].sizes && colorArray[0].sizes[0] && colorArray[0].sizes[0].oldPrice ? 'saldo' : 'temporada';
                }
            }

            return state;
        }

        function getSizeId(colorArray, sizeSku, colorId) {
            var sizeId;
            if (colorArray && colorArray.length !== 0) {
                if (sizeSku) {
                    colorArray.map(function (color) {
                        let sizeIndex = -1;
                        if (color && color.sizes && color.sizes.length) {
                            sizeIndex = color.sizes.findIndex(function (size) {
                                return size.sku === sizeSku;
                            });
                        }
                        if (sizeIndex !== -1) {
                            sizeId = color.sizes[sizeIndex].mastersSizeId;
                        }
                    });
                } else if (colorId) {
                    var colorSelected = colorArray.find(function (color) {
                        return color.id === colorId;
                    });
                    sizeId = colorSelected && colorSelected.sizes && colorSelected.sizes[0] ? colorSelected.sizes[0].mastersSizeId : undefined;
                } else {
                    sizeId = colorArray[0].sizes[0] ? colorArray[0].sizes[0].mastersSizeId : undefined;
                }
            }
            if (sizeId && sizeId.length > 2) {
                sizeId = sizeId.substr(1);
            }
            return sizeId;
        }

        function getSizeName(colorArray, sizeSku, colorId) {
            var sizeName;
            if (colorArray && colorArray.length !== 0) {
                if (sizeSku) {
                    colorArray.map(function (color) {
                        var sizeIndex = color.sizes.findIndex(function (size) {
                            return size.sku === sizeSku;
                        });
                        if (sizeIndex !== -1) {
                            sizeName = color.sizes[sizeIndex].name;
                        }
                    });
                } else if (colorId) {
                    var colorSelected = colorArray.find(function (color) {
                        return color.id === colorId;
                    });
                    sizeName = colorSelected && colorSelected.sizes && colorSelected.sizes[0] ? colorSelected.sizes[0].name : undefined;
                } else {
                    sizeName = colorArray[0].sizes[0] ? colorArray[0].sizes[0].name : undefined;
                }
            }
            return sizeName;
        }

        function getStockColor(colorArray, colorId) {
            var stock = 'no';

            var colorSelected = colorArray.find(function (color) {
                return color.id === colorId;
            });

            if (colorSelected && colorSelected.sizes && colorSelected.sizes.length > 0) {
                stock = 'si';
            }

            return stock;
        }

        function getColorName(colorArray, colorId) {
            var colorName;
            if (colorArray && colorArray.length !== 0) {
                var colorIndex;

                if (typeof colorId === 'string') {
                    colorIndex = colorArray.findIndex(function (color) {
                        return color.id === colorId;
                    });
                } else if (typeof colorId === 'number') {
                    colorIndex = colorId;
                } else {
                    colorIndex = 0;
                }
                if (colorIndex === -1) {
                    colorIndex = 0;
                }

                colorName = colorArray[colorIndex].name;
            }
            return colorName;
        }

        function getColorId(colorArray, colorId) {
            var colorName;

            if (colorArray && colorArray.length !== 0) {
                if (typeof colorId === 'number') {
                    colorName = colorArray[colorId].id;
                } else if (typeof colorId === 'string') {
                    var colorIndex = colorArray.findIndex(function (color) {
                        return color.id === colorId;
                    });
                    if (colorIndex >= 0) {
                        colorName = colorId;
                    } else {
                        colorName = colorArray[0].id;
                    }
                } else {
                    colorName = colorArray[0].id;
                }
            }
            return colorName;
        }

        function getSeason(partnumber) {
            return partnumber.substr(partnumber.indexOf('-') + 1);
        }

        function getStock(item) {
            var stock = item.unitsAvailable;
            return stock && stock !== 0 ? 'si' : 'no';
        }

        function getProductClass(partNumber) {
            return partNumber[0];
        }

        function searchProductInCart(productId) {
            var index = inditex.iUserJSON.shopCart.items.findIndex(function (item) {
                return item.parentId === productId;
            });

            return inditex.iUserJSON.shopCart.items[index];
        }

        function getPrice(product) {
            var item = searchProductInCart(product.id);
            return item.unitPrice;
        }

        function getIndexCart(productId) {
            var index = -1;
            if (inditex && inditex.iUserJSON && inditex.iUserJSON.shopCart) {
                index = inditex.iUserJSON.shopCart.items.findIndex(function (item) {
                    return item.parentId === productId;
                });
            }

            if (index === -1) {
                index = undefined;
            }
            return index;
        }
    }
})();

(function () {
    'use strict';

    angular.module('imAnalytics').service('imObjectData', [imObjectData]);

    function imObjectData() {
        return {
            getProductData: getProductData,
            getCartData: getCartData,
            getPhotoData: getPhotoData,
            getCategoryData: getCategoryData,
            getPageData: getPageData,
            getLookData: getLookData,
            getContextData: getContextData,
            getEventData: getEventData,
            getUserData: getUserData,
            getSearchData: getSearchData,
            getOrderData: getOrderData,
            getStoreData: getStoreData,
            getCategoryPath: getCategoryPath,
            isQuickbuy: isQuickbuy,
            getUserBase: getUserBase,
            getSection: getSection,
            getCategoryPathHome: getCategoryPathHome,
            getViewType: getViewType,
            getCategoryJSON: getCategoryJSON,
            getCategoryDataById: getCategoryDataById,
            getUserId: getUserId,
            getStoreId: getStoreId,
            getHashEmailSha256: getHashEmailSha256,
        };

        function getContextData() {
            var contextObject = {
                platform: 'web-responsive',
                codeVersion: '8.8.0',
                imCv: '1.1.8.1',
                storeId: getStoreId(),
                language: getLanguage(),
                isOpenStore: getOpenStore(),
                hashEmail: getHashEmail()
            };

            return contextObject;
        }

        function getOrderData(order) {
            var orderObject = {
                orderId: order.id,
                payment: {
                    type: getPaymentType(order),
                    giftcardAmount: undefined,
                    affinity: undefined,
                    netAmount: netAmount(order),
                    savedData: isWallet(),
                    giftTicket: getGiftTicket(order)
                },
                delivery: {
                    shippingType: order.shipping ? order.shipping.name : undefined,
                    weekday: undefined,
                    time: undefined
                },
                discount: {
                    discountType: getDiscountType(order),
                    fullAmount: inditex.formatNumber(order.totalAdjustment)
                }
            };

            return orderObject;
        }
        /*PRIVATE FUNCTIONS*/
        function getGiftTicket(order) {
            return order.giftTicket ? 'no' : 'si';
        }

        function getViewType() {
            if (window.imAnalytics && window.imAnalytics.angularGrid && window.imAnalytics.angularGrid != '') {
                var numItems = 0;
                switch (window.imAnalytics.angularGrid) {
                    case 1:
                        numItems = 1;
                        break;
                    case 2:
                        numItems = 4;
                        break;
                    case 3:
                        numItems = 12;
                        break;
                    default:
                        break;
                }
                window.imAnalytics.angularGrid = '';
                return numItems;
            } else {
                var layoutExpanded = JSON.parse(inditex.getLocalStorage('LAYOUT_EXPANDED')) || false;
                return layoutExpanded ? '4' : '2';
            }
        }

        function netAmount(order) {
            order = order || '';
            var result = inditex.formatNumber(order.totalOrder);
            result = result - order.tax;
            if (order.shippingPrice) {
                var isDiscount = false;
                for (var i = 0; i < order.adjustment.length; i++) {
                    if (order.adjustment[i].isShipping === true) {
                        isDiscount = true;
                        break;
                    }
                }
                if (!isDiscount) {
                    result = result - inditex.formatNumber(order.shippingPrice);
                }
            }
            return result;
        }

        function isWallet() {
            var type;
            if ('iUserJSON' in inditex && 'isWalletUser' in inditex.iUserJSON) {
                if (inditex.iUserJSON.isWalletUser) {
                    type = 'si';
                } else {
                    type = 'no';
                }
            }

            return type;
        }
        function getPaymentType(order) {
            var type = [];
            if (order.payment && order.payment.length > 0) {
                for (var i = 0; i < order.payment.length; i++) {
                    type.push(order.payment[i].name);
                }
                type = type.join(';');
                return type;
            } else {
                return undefined;
            }
        }
        function getDiscountType(order) {
            var type = [];
            if (order.adjustment && order.adjustment.length > 0) {
                for (var i = 0; i < order.adjustment.length; i++) {
                    type.push(order.adjustment[i].type);
                }
                type = type.join(';');
                return type;
            } else {
                return undefined;
            }
        }
        /*=========================================*/

        function getStoreData(store) {
            var storeObject = {
                storeFound: store ? store.id : undefined,
                zipCode: store ? store.zipCode : undefined
            };
            return storeObject;
        }

        function getLookData(lookReference, bundleRef) {
            var lookObject = {
                lookReference: lookReference,
                bundleReference: bundleRef
            };

            return lookObject;
        }

        function getPageData(pageUrl, section, pageType, pageTitle) {
            if (!pageUrl) {
                pageUrl = window.location.href;
            }

            var pageObject = {
                pageURL: pageUrl,
                section: section,
                pageType: pageType,
                pageTitle: pageTitle,
                countryCode: inditex.iCountryCode,
                categoryId: undefined
            };
            return pageObject;
        }
        function getUserData() {
            var userObject = {
                userId: getUserId(),
                isLogged: getLogged(),
                userType: getUserType(),
                quickBuy: undefined,
                isBuyer: getBuyer(),
                clientType: getClientType(),
                sex: getSex(),
                fidelization: getFidelization() ? 'si' : 'no',
                us: getHashEmailSha256()
            };

            return userObject;
        }

        function getUserBase() {
            var userObject = {
                userId: getUserId(),
                isLogged: getLogged()
            };
            return userObject;
        }

        function getHashEmail() {
            if ((inditex.iUserJSON && inditex.iUserJSON.email) || window.imAnalytics.email) {
                var hash = md5(inditex.iUserJSON.email);
                return hash.toString();
            }
            return undefined;
        }

        function getHashEmailSha256() {
            if ((inditex.iUserJSON && inditex.iUserJSON.email) || window.imAnalytics.email) {
                var hash = CryptoJS.SHA256(inditex.iUserJSON.email);
                return hash.toString();
            }
            return undefined;
        }

        /* PRIVATE FUNCTIONS FOR GET USER DATA */
        function getSex() {
            // body...
            var sex;
            if (inditex.iUserJSON && inditex.iUserJSON.gender === 'M') {
                return (sex = 'hombre');
            } else if (inditex.iUserJSON && inditex.iUserJSON.gender === 'F') {
                return (sex = 'mujer');
            } else {
                return (sex = undefined);
            }
        }

        function getFidelization() {
            var iUserJSON = undefined;
            if (inditex) {
                iUserJSON = inditex.iUserJSON;
            }

            const localStorage360 = inditex.getLocalStorage('USER_360');

            if (localStorage360 !== undefined && localStorage360 !== null) {
                const debug360 = localStorage360 === 'true' ? true : false;
                return debug360;
            } else {
                const userJson360 = (iUserJSON && iUserJSON.is360) || false; //se añade el || false para que siempre devuelva un boolean
                return userJson360;
            }
        }

        function getClientType() {
            var type;
            if ('iUserJSON' in inditex && 'isCompany' in inditex.iUserJSON) {
                if (inditex.iUserJSON && inditex.iUserJSON.isCompany) {
                    type = 'empresa';
                } else {
                    type = 'particular';
                }
            }
            return type;
        }

        function getBuyer() {
            var type;

            if ('iUserJSON' in inditex && 'isBuyer' in inditex.iUserJSON) {
                if (inditex.iUserJSON.isBuyer) {
                    type = 'si';
                } else {
                    type = 'no';
                }
            }
            return type;
        }
        function isQuickbuy() {
            var isQuickbuy = 'no';
            if (inditex.iUserJSON && inditex.iUserJSON.isWalletUser) {
                isQuickbuy = 'si';
            } else {
                isQuickbuy = 'no';
            }
            return isQuickbuy;
        }

        function getLogged() {
            var isLogged = 'no_logueado';
            if ('iUserJSON' in inditex && 'userType' in inditex.iUserJSON) {
                if (inditex.iUserJSON.userType === 'G') {
                    isLogged = 'no_logueado';
                }
                if (inditex.iUserJSON.userType === 'R') {
                    isLogged = 'logueado';
                }
            }
            return isLogged;
        }
        /** ==========================================*/

        function getCategoryData(productInfo) {
            var categoryObject = {
                season: productInfo.season,
                category: productInfo.category,
                subcategory: undefined,
                subsubcategory: undefined,
                itemsNumber: undefined, //TODO: numberOfProducts es 0.
                viewType: undefined, // TODO: type
                filter: undefined,
                sortType: undefined
            };
            return categoryObject;
        }
        function getCategoryType(cat) {
            var cat = cat || inditex.iCategoryJSON;
            var key;
            if (cat) {
                if (cat.key.search('WOMEN') !== -1 || cat.key.search('WOMAN') !== -1) {
                    return 'WOMEN';
                } else if (cat.key.search('MEN') !== -1) {
                    return 'MEN';
                } else if (cat.key.search('BOYS') !== -1 || cat.key.search('NIÑO') !== -1) {
                    return 'BOYS';
                } else if (cat.key.search('GIRLS') !== -1 || cat.key.search('NIÑA') !== -1) {
                    return 'GIRLS';
                }
            }
            return key;
        }
        function getCategoryJSON(categoryId) {
            var iCategoryTreeJSON = inditex.iCategoryTreeJSON && inditex.iCategoryTreeJSON.categories;
            return joyr.catalog.utils.findCategoryById(categoryId, iCategoryTreeJSON);
        }

        function getCategoryDataById(categoryId) {
            var categoryJSON = getCategoryJSON(parseInt(categoryId));
            return getCategoryPathHome(categoryJSON);
        }

        //Orientado para las paginas o a la lista no a los productos
        function getCategoryPath(categoryJSON) {
            var cat = categoryJSON || inditex.iCategoryJSON;
            var title = [];
            var category;

            if (cat && cat.pageName) {
                title = cat.pageName.split('/');
            }

            if (cat && !cat.pageName) {
                category = cat.nameEn;
                title.push(category);
                if (cat.parentCategory) {
                    category = cat.parentCategory.nameEn;
                    title.push(category);
                }
                if (cat.parentCategory && cat.parentCategory.parentCategory) {
                    category = cat.parentCategory.parentCategory.nameEn;
                    title.push(category);
                }
                var genre = getCategoryType(cat);

                if (genre && genre !== title[title.length - 1]) {
                    title.push(genre);
                }
                title = title.reverse();
            }
            var categoryPath = {
                category: title[0],
                subcategory: title[1],
                subsubcategory: title[2] ? title.slice(2).join('/') : undefined,
                categoryPath: title.join('/') ? title.join('/') : undefined
            };
            return categoryPath;
        }

        function getCategoryPathHome(categoryJSON) {
            var cat = categoryJSON || inditex.iCategoryJSON || {};
            var title = [];
            var category;

            if (cat && cat.parentCategory) {
                category = cat.nameEn;
                title.push(category);
                if (cat.parentCategory) {
                    category = cat.parentCategory.nameEn;
                    title.push(category);
                }
                if (cat.parentCategory && cat.parentCategory.parentCategory) {
                    category = cat.parentCategory.parentCategory.nameEn;
                    title.push(category);
                }
                var genre = getCategoryType(cat);

                if (genre && genre !== title[title.length - 1]) {
                    title.push(genre);
                }
                title = title.reverse();
            } else {
                if (cat.parentcategories && cat.parentcategories instanceof Array) {
                    cat.parentcategories.forEach(function (item) {
                        title.push(item.nameEn);
                    });
                }
                title.push(cat.nameEn);
            }
            var categoryPath = {
                category: title[0],
                subcategory: title[1],
                subsubcategory: title[2] ? title.slice(2).join('/') : undefined,
                categoryPath: title.join('/') ? title.join('/') : undefined
            };
            return categoryPath;
        }

        function getProductData(productInfo) {
            var productObject = {
                reference: productInfo.id,
                key: productInfo.key,
                productState: productInfo.productState,
                claseProducto: productInfo.claseProducto,
                consumerProduct: productInfo.consumerProduct,
                onlineOnly: undefined,
                stock: productInfo.stock,
                color: productInfo.color || productInfo.dimension96,
                talla: productInfo.size || productInfo.dimension97,
                model: productInfo.model
            };

            return productObject;
        }

        function getCartData(cartItems) {
            var cartObject;

            if (Array.isArray(cartItems)) {
                cartObject = {
                    cartNumberItems: cartItems.length,
                    cartNumberItemsNoStock: getCartShopStock(cartItems),
                    cartProducts: getShopCartProducts(cartItems)
                };
            } else {
                cartObject = {
                    cartNumberItems: cartItems.quantity,
                    cartNumberItemsNoStock: getCartShopStock(cartItems),
                    cartProducts: undefined
                };
            }

            return cartObject;
        }

        function getPhotoData(linktype) {
            var photo = {
                lightType: undefined,
                background: undefined,
                typePhoto: undefined,
                linkType: linktype
            };

            return photo;
        }

        function getEventData(cf, category, action, label) {
            var eventDataObject = {
                cf: cf,
                category: category,
                action: action,
                label: label
            };

            return eventDataObject;
        }

        function getSearchData(searchTerm, searchResultNr) {
            var searchObject = {
                searchTerm: searchTerm,
                searchResultNr: searchResultNr
            };

            return searchObject;
        }

        /*PRIVATE FUNCTIONS*/
        function getCartShopStock(products) {
            var productArray = [];
            if (!Array.isArray(products)) {
                // If object convert to array
                productArray.push(products);
            } else {
                productArray = products;
            }

            var noStock = productArray.filter(function (item) {
                return item.availability !== 'in_stock';
            });

            return noStock.length;
        }

        function getShopCartProducts(items) {
            var products = [];
            for (var i = 0, len = items.length; i < len; i++) {
                products.push({
                    reference: items[i].reference,
                    quantity: items[i].quantity,
                    key: items[i].parentId
                });
            }
            return products;
        }

        function getLanguage() {
            if (inditex.iLocale) {
                return inditex.iLocale.substring(0, 2).toLowerCase();
            } else {
                return undefined;
            }
        }

        function getOpenStore() {
            if (inditex && inditex.iStoreJSON) {
                return inditex.iStoreJSON.isOpenForSale ? 'abierta' : 'cerrada';
            }
        }

        function getStoreId() {
            if (inditex.iPage === 'ItxWorldWidePage') {
                return 'DUTTI_ZZ';
            } else {
                if (inditex.iStoreIdentifier) {
                    return inditex.iStoreIdentifier.replace(/(.*)([a-zA-Z]{2})/, '$1_$2').toUpperCase();
                } else {
                    return undefined;
                }
            }
        }

        /**
         * Si el userId > 0 está logueado
         */
        function getUserId() {
            if (inditex.iUserJSON) {
                if (inditex.iUserJSON.identity) {
                    return inditex.iUserJSON.identity.userId > 0 ? inditex.iUserJSON.identity.userId : undefined;
                } else {
                    return undefined;
                }
            } else {
                return undefined;
            }
        }

        function getUserType() {
            if (inditex.iUserJSON && inditex.iUserJSON.userType === 'R') {
                return 'registrado';
            } else {
                return 'anonimo';
            }
        }

        /*============*/

        function getSection() {
            var section = inditex.getLocalStorage('LAST_SECTION') || section;
            if (section) {
                section = section.toLowerCase();
                if (section === 'bg') {
                    section = 'boys & girls';
                }
                return '_' + section;
            }
            return '';
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('imAnalytics')
        .service('imPopupService', [
            'DEBUG',
            'PRODUCT_DETAIL',
            'imProductDataService',
            'imCommonService',
            'imDataService',
            'imEventService',
            'imObjectData',
            '$window',
            imPopupService
        ]);

    function imPopupService(DEBUG, PRODUCT_DETAIL, imProductDataService, imCommonService, imDataService, imEventService, imObjectData, $window) {
        return {
            sendBasic: sendBasic,
            sendPopup: sendPopup,
            sendPopupEcommerce: sendPopupEcommerce,
            sendRelatedPopup: sendRelatedPopup
        };

        function sendPopupEcommerce(product, colorIndex, position) {
            var ecomerceObject = PRODUCT_DETAIL;
            ecomerceObject.ecommerce.currencyCode = imCommonService.replaceValue(
                ecomerceObject.ecommerce.currencyCode,
                imDataService.getCurrencyCode()
            );
            ecomerceObject.ecommerce.detail.actionField.list = undefined;
            imProductDataService.getProductInfo(product, null, colorIndex).then(function (productInfo) {
                var productObject = {
                    id: productInfo.id,
                    name: productInfo.name,
                    category: productInfo.category,
                    position: undefined, //Establecemos a undefined la position. Se envía en el click o detail
                    dimension96: productInfo.color,
                    dimension99: productInfo.dimension99,
                    dimension100: productInfo.dimension100,
                    dimension101: productInfo.dimension101,
                    dimension117: productInfo.dimension117,
                    dimension109: productInfo.section,
                    dimension111: productInfo.family,
                    dimension113: productInfo.subfamily,
                    dimension146: imProductDataService.getLastSearchFromCookies(),
                    price: productInfo.price,
                    key: productInfo.key,
                    gridElemType: productInfo.gridElemType,
                    dimension29: productInfo.isCustomizable
                };
                ecomerceObject.ecommerce.detail.products = imCommonService.replaceProduct(ecomerceObject.ecommerce.detail.products, [productObject]);

                sendPopup(colorIndex, ecomerceObject, productInfo);
            });
        }

        function sendPopup(colorIndex, ecomerceObject, productInfo) {
            var section, pageType, pageTitle, lookRef, refBundle;
            switch (inditex.iPage) {
                case 'ItxProductPage':
                    section = 'catalogo';
                    refBundle = sessionStorage.getItem('bundleRef') + '-' || '';
                    pageType = 'vista_rapida_producto_bundle';
                    pageTitle = refBundle + productInfo.partNumberColor + '/detalles_producto';
                    if (productInfo.isRelated) {
                        pageType = 'vista_rapida_producto_cross';
                        pageTitle = productInfo.partNumberColor + '/detalles_producto';
                    }
                    break;

                case 'ItxShopCartPage':
                    section = 'checkout';
                    pageType = 'cesta';
                    pageTitle = 'vista_rapida_producto/' + productInfo.partNumberColor + '/detalles_producto';
                    if (productInfo.isRelated) {
                        pageTitle = 'vista_rapida_producto_cross/' + productInfo.partNumberColor + '/detalles_producto';
                    }
                    break;

                case 'ItxCategoryPage':
                    section = 'catalogo';
                    pageType = 'vista_rapida_producto';
                    pageTitle = productInfo.partNumberColor + '/detalles_producto';
                    if (document.getElementById('lookbook')) {
                        lookRef = window.sessionStorage.getItem('lookRef', lookRef);
                        pageTitle = inditex.iCategoryJSON.nameEn + '-' + lookRef + '-' + productInfo.partNumberColor + '/detalles_producto';
                    }
                    break;

                case 'ItxCheckoutPage':
                    section = 'checkout';
                    pageType = 'resumen_compra';
                    pageTitle = 'vista_rapida_producto/' + productInfo.partNumberColor + '/detalles_producto';
                    break;
            }

            var popupObject = {
                page: imObjectData.getPageData(null, section, pageType, pageTitle),
                category: imObjectData.getCategoryPath(),
                product: imObjectData.getProductData(productInfo),
                photo: imObjectData.getPhotoData(),
                look: imObjectData.getLookData(lookRef, refBundle),
                user: imObjectData.getUserBase()
            };
            popupObject.category.season = productInfo.season;

            imEventService.popupView([popupObject], ecomerceObject);
        }

        function sendRelatedPopup(product) {
            imProductDataService.getProductInfo(product).then(function (productInfo) {
                var popupObject = {
                    event: 'popupView',
                    page: {
                        section: 'catalogo',
                        pageTitle: productInfo.partNumberColor + '/productos_relacionados'
                    },
                    category: imObjectData.getCategoryPath(),
                    ecommerce: undefined,
                    look: undefined,
                    order: undefined,
                    photo: undefined,
                    searchEngine: undefined,
                    store: undefined,
                    cart: undefined
                };
                popupObject.category.season = productInfo.season;
                //Mantener persistencia
                dataLayer.push(popupObject);
            });
        }

        function sendBasic(section, pageType, pageTitle) {
            var popupObject = [
                {
                    page: imObjectData.getPageData(null, section, pageType, pageTitle)
                }
            ];

            imEventService.popupView(popupObject);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('imAnalytics')
        .service('imProductService', [
            'PRODUCT_DETAIL',
            'ADD_CART',
            'PRODUCT_CLICK',
            'imEventService',
            'imCommonService',
            'imDataService',
            'imObjectData',
            'imProductDataService',
            '$window',
            'ItxUtilsFct',
            'ItxConstants',
            'ItxSizeGuideSvc',
            imProductService
        ]);

    function imProductService(
        PRODUCT_DETAIL,
        ADD_CART,
        PRODUCT_CLICK,
        imEventService,
        imCommonService,
        imDataService,
        imObjectData,
        imProductDataService,
        $window,
        ItxUtilsFct,
        ItxConstants,
        ItxSizeGuideSvc
    ) {
        return {
            productDetail: productDetail,
            eventSelectSize: eventSelectSize,
            eventSelectColor: eventSelectColor,
            isProductDialog: isProductDialog,
            isLookbook: isLookbook,
            eventSocialShare: eventSocialShare,
            eventStoreStock: eventStoreStock,
            eventProductInfo: eventProductInfo,
            createView: createView,
            eventZoom: eventZoom,
            eventSizeGuide: eventSizeGuide,
            eventHelpPage: eventHelpPage,
            eventChangePhoto: eventChangePhoto,
            getPosition: getPosition,
            createViewBundle: createViewBundle,
            goToShoppingCart: goToShoppingCart,
            eventAddToCart: eventAddToCart,
            eventRelatedProductClick: eventRelatedProductClick,
            parseEcommerceProduct: parseEcommerceProduct,
            productClick: productClick,
            isPopupHomeBundle: isPopupHomeBundle,
            sendProductViewToHero: sendProductViewToHero
        };

        function isProductDialog() {
            return angular.element('.ngdialog.ma-dialog').length === 1;
        }
        function isPopupHomeBundle() {
            return angular.element('.cmp-bundle-v19-detail').length === 1;
        }

        function isLookbook() {
            return document.getElementById('lookbook') ? true : false;
        }
        function isSaveForLaterTab() {
            return angular.element('.shopcart-items-tab.shopcart.ng-hide').length === 1;
        }

        //Private function
        function getEventCategory(product) {
            var category = 'ficha_producto';
            if (inditex.iPage === 'ItxProductPage' && isProductDialog()) {
                if (imDataService.isBundle(product)) {
                    category = 'bundle_vista_rapida_producto';
                } else {
                    category = 'vista_rapida_producto_cross';
                }
            } else if (inditex.iPage === 'ItxShopCartPage' && isProductDialog()) {
                category = 'cesta_vista_rapida_producto';
                if (product.isRelated) {
                    category = 'cesta_vista_rapida_producto_cross';
                }
            } else if (inditex.iPage === 'ItxCategoryPage' && isProductDialog()) {
                category = 'vista_rapida_producto';
                if (isLookbook()) {
                    category = 'lookbook_vista_rapida_producto';
                }
            } else if (inditex.iPage === 'ItxCheckoutPage' && isProductDialog()) {
                category = 'resumen_vista_rapida_producto';
            }
            return category;
        }

        function eventHelpPage(product) {
            var category = getEventCategory(product);
            var dataObject = {
                eventData: imObjectData.getEventData('ayuda', category, 'ver_ayuda')
            };
            sendEvent([dataObject]);
        }

        function eventSizeGuide(product) {
            var category;
            switch (inditex.iPage) {
                case 'ItxProductPage':
                    category = 'ficha_producto';
                    if (imDataService.isBundle(product)) {
                        category = 'bundle_vista_rapida_producto';
                    } else if (product.isRelated) {
                        category = 'vista_rapida_producto_cross';
                    }
                    break;
                case 'ItxShopCartPage':
                    category = 'cesta_vista_rapida_producto';
                    if (product.isRelated) {
                        category = 'cesta_vista_rapida_producto_cross';
                    }
                    break;

                case 'ItxCategoryPage':
                    category = 'vista_rapida_producto';
                    if (isLookbook()) {
                        category = 'lookbook_vista_rapida_producto';
                    }
                    break;

                case 'ItxCheckoutPage':
                    category = 'resumen_vista_rapida_producto';
                    break;
            }
            var dataObject = {
                eventData: imObjectData.getEventData('ayuda', category, 'ver_guia_tallas')
            };
            sendEvent([dataObject]);
        }

        function eventZoom(index) {
            var category = getEventCategory();

            var dataObject = {
                eventData: imObjectData.getEventData('catalogo', category, 'ver_zoom', index + 1),
                customData: { photo: imObjectData.getPhotoData() }
            };
            sendEvent([dataObject]);
        }

        function eventChangePhoto(index) {
            var category = getEventCategory();

            var dataObject = {
                eventData: imObjectData.getEventData('catalogo', category, 'ver_foto_auxiliar', index + 1),
                customData: { photo: imObjectData.getPhotoData() }
            };
            sendEvent([dataObject]);
        }

        function getPosition() {
            var position = window.sessionStorage.getItem('searchPosition');
            window.sessionStorage.removeItem('searchPosition');
            if (!position) {
                position = window.sessionStorage.getItem('BACK_TO_GRID_PRODUCT_' + inditex.iCategoryId)
                    ? JSON.parse(window.sessionStorage.getItem('BACK_TO_GRID_PRODUCT_' + inditex.iCategoryId)).index
                    : undefined;
            }
            return typeof position !== 'undefined' ? parseInt(position) + 1 : undefined;
        }

        function createView(product, colorIndex, list, position) {
            imProductDataService.getProductInfo(product, null, colorIndex).then(function (productInfo) {
                var dataObject = {
                    category: imObjectData.getCategoryPath(),
                    photo: imObjectData.getPhotoData(),
                    product: imObjectData.getProductData(productInfo),
                    page: imObjectData.getPageData(null, 'catalogo', 'ficha_producto', productInfo.partNumberColor + '/detalles_producto'),
                    context: imObjectData.getContextData(),
                    user: imObjectData.getUserBase()
                };
                //Section
                dataObject.category.season = productInfo.season;

                var productObject = parseEcommerceProduct([productInfo]);

                var list = imDataService.getList(product);
                //var position = getPosition();
                productDetail([dataObject], imDataService.getCurrencyCode(), list, productObject);
            });
        }

        /**
         * Función para mandar las analíticas de visualización de un producto a Hero
         */
        function sendProductViewToHero(product) {
            // Obtén las imágenes del producto
            var images = ItxUtilsFct.getProductXmediaImagesData(product, ItxConstants.xmediaLocations['productPage']);

            // Obtén las tallas del producto
            var productSizes = ItxSizeGuideSvc.removeDuplicates(product.activeDetail.colors[product.state.selectedColorIndex].sizes);

            // Extendemos la información del producto recibido
            imProductDataService.getProductInfo(product, null, product.state.selectedColorIndex).then(function (productInfo) {
                // Obtén el SKU del producto
                var productSku;

                if (product.state.selectedSize) {
                    productSku = product.state.selectedSize;
                } else {
                    productSku = _.filter(productSizes, function (size) {
                        return size.name === productInfo.sizeName;
                    });

                    productSku = productSku[0];
                }

                const heroAnalytics = {
                    id: productSku.partnumber,
                    name: product.name,
                    image: images.length > 0 ? images[0].url.replace('http://', 'https://') : '',
                    price: Number(productInfo.price),
                    currency: imDataService.getCurrencyCode(),
                    brand: 'Massimo Dutti',
                    category: imObjectData.getCategoryPath().categoryPath,
                    variant: `Color: ${productInfo.colorName} - Size: ${product.state.selectedSize ? product.state.selectedSize.name : productInfo.sizeName
                        }`,
                    location: window.location.href
                };

                setTimeout(function () {
                    if (typeof hero !== 'undefined' && heroAnalytics) {
                        hero('track', {
                            type: 'ecommerce:detail',
                            products: [heroAnalytics]
                        });
                    }
                }, 2000);
            });
        }

        function createViewBundle(product, colorIndex) {
            var bundleRef = product.detail ? product.detail.reference : undefined;
            window.sessionStorage.setItem('bundleRef', bundleRef);
            imProductDataService.getBundleInfo(product).then(function (productInfo) {
                var dataObject = {
                    category: imObjectData.getCategoryPath(),
                    //product: imObjectData.getProductData(productInfo),
                    photo: imObjectData.getPhotoData(),
                    page: imObjectData.getPageData(null, 'catalogo', 'ficha_bundle', bundleRef + '/detalles_bundle'),
                    context: imObjectData.getContextData(),
                    look: imObjectData.getLookData(undefined, bundleRef),
                    user: imObjectData.getUserBase()
                };
                var list = imDataService.getList(product);

                var products = parseEcommerceProduct(productInfo);
                productDetail([dataObject], imDataService.getCurrencyCode(), list, products);
            });
        }

        function parseEcommerceProduct(products) {
            products = products || [];
            return products.map(function (productInfo, index) {
                return {
                    name: productInfo.name,
                    id: productInfo.id,
                    price: productInfo.price,
                    category: productInfo.category,
                    dimension96: productInfo.color,
                    dimension99: productInfo.dimension99,
                    dimension100: productInfo.dimension100,
                    dimension101: productInfo.dimension101,
                    dimension117: productInfo.dimension117,
                    dimension109: productInfo.section,
                    dimension111: productInfo.family,
                    dimension113: productInfo.subfamily,
                    dimension146: imProductDataService.getLastSearchFromCookies(),
                    isRelated: productInfo.isRelated,
                    key: productInfo.key,
                    partNumberColor: productInfo.partNumberColor,
                    gridElemType: productInfo.gridElemType,
                    dimension29: productInfo.isCustomizable
                };
            });
        }

        function productClick(dataObject, productObject) {
            var list = imDataService.getList();
            inditex.setSessionStorage('imList', list);
            var ecomerceObject = PRODUCT_CLICK;
            ecomerceObject.ecommerce.currencyCode = imDataService.getCurrencyCode();
            ecomerceObject.ecommerce.click.actionField.list = imCommonService.replaceValue(ecomerceObject.ecommerce.click.actionField.list, list);
            ecomerceObject.ecommerce.click.products = imCommonService.replaceProduct(ecomerceObject.ecommerce.click.products, productObject);
            imEventService.analyticsEvent([dataObject], ecomerceObject);
        }

        function productDetail(data, currencyCode, list, products) {
            var ecommerceObject = PRODUCT_DETAIL;
            ecommerceObject.ecommerce.currencyCode = imCommonService.replaceValue(ecommerceObject.ecommerce.currencyCode, currencyCode);
            ecommerceObject.ecommerce.detail.actionField.list = imCommonService.replaceValue(ecommerceObject.ecommerce.detail.actionField.list, list);
            ecommerceObject.ecommerce.detail.products = imCommonService.replaceProducts(ecommerceObject.ecommerce.detail.products, products);

            imEventService.pageView(data, ecommerceObject);

            //Se expone la última lista del detalle para fitAnalytics.
            window.sessionStorage.setItem('imFitAnalytics', list);
        }

        function eventSelectColor(product, color) {
            imProductDataService.getProductInfo(product, null, color).then(function (productInfo) {
                var dataObject = getData(productInfo, 'seleccionar_color', '-color_');
                sendEvent([dataObject]);
            });
        }
        function getDataFromCategory(productInfo, action, subString) {
            var refLook, label, category;
            var cf = 'catalogo';

            if (isLookbook()) {
                refLook = window.sessionStorage.getItem('lookRef');
                if (subString === '-talla_') {
                    label = refLook + '-' + productInfo.partNumberColor + subString + productInfo.size;
                } else if (subString === '-color_') {
                    label = refLook + '-' + productInfo.partNumberColor + subString + productInfo.color;
                }
                if (isProductDialog()) {
                    category = 'lookbook_vista_rapida_producto';
                } else {
                    category = 'ficha_look';
                }
            } else {
                category = 'parrilla';
                if (isProductDialog()) {
                    category = 'vista_rapida_producto';
                }
                if (subString === '-talla_') {
                    label = productInfo.partNumberColor + subString + productInfo.size;
                } else if (subString === '-color_') {
                    label = productInfo.partNumberColor + subString + productInfo.color;
                }
            }

            return {
                action: action,
                label: label,
                category: category,
                refLook: refLook,
                cf: cf
            };
        }

        function getDataFromProduct(productInfo, action, subString) {
            var refBundle, label, category;
            var cf = 'catalogo';

            if (subString === '-talla_') {
                label = productInfo.partNumberColor + subString + productInfo.size;
            } else if (subString === '-color_') {
                label = productInfo.partNumberColor + subString + productInfo.color;
            }
            if (imDataService.isBundle(productInfo)) {
                refBundle = sessionStorage.getItem('bundleRef') + '-' || '';
                label = refBundle + label;
                refBundle = refBundle.replace('-', '');
            }
            if (isProductDialog()) {
                if (imDataService.isBundle(productInfo)) {
                    category = 'bundle_vista_rapida_producto';
                } else {
                    category = 'vista_rapida_producto_cross';
                }
            } else {
                category = 'ficha_producto';
                if (imDataService.isBundle(productInfo)) {
                    category = 'ficha_bundle';
                }
            }

            return {
                action: action,
                label: label,
                category: category,
                refBundle: refBundle,
                cf: cf
            };
        }
        function getDataFromCart(productInfo, action, subString) {
            var refLook, label, category;
            var cf = 'catalogo';
            if (subString === '-talla_') {
                label = productInfo.partNumberColor + subString + productInfo.size;
            } else if (subString === '-color_') {
                label = productInfo.partNumberColor + subString + productInfo.color;
            }
            if (isProductDialog()) {
                category = 'cesta_vista_rapida_producto';
                if (productInfo.isRelated) {
                    category = 'cesta_vista_rapida_producto_cross';
                }
            } else {
                cf = 'checkout';
                category = 'cesta';
            }
            return {
                action: action,
                label: label,
                category: category,
                refLook: refLook,
                cf: cf
            };
        }

        function getData(productInfo, action, subString) {
            var data = {};
            switch (inditex.iPage) {
                case 'ItxCategoryPage':
                    data = getDataFromCategory(productInfo, action, subString);
                    break;

                case 'ItxProductPage':
                    data = getDataFromProduct(productInfo, action, subString);
                    break;

                case 'ItxShopCartPage':
                    data = getDataFromCart(productInfo, action, subString);
                    break;

                case 'ItxCheckoutPage':
                    var label;
                    if (subString === '-talla_') {
                        label = productInfo.partNumberColor + subString + productInfo.size;
                    } else if (subString === '-color_') {
                        label = productInfo.partNumberColor + subString + productInfo.color;
                    }
                    data = {
                        label: label,
                        category: 'resumen_vista_rapida_producto',
                        action: action,
                        refLook: undefined,
                        cf: 'catalogo'
                    };
                    break;
            }

            if (imDataService.isSearch()) {
                //Eventos buscador
                data.cf = 'catalogo';
                data.category = 'buscador';
                data.action = action;
                if (subString === '-talla_') {
                    data.label = productInfo.partNumberColor + subString + productInfo.size;
                } else if (subString === '-color_') {
                    data.label = productInfo.partNumberColor + subString + productInfo.color;
                }
            }

            var dataObject = {
                eventData: imObjectData.getEventData(data.cf, data.category, data.action, data.label),
                customData: {
                    product: imObjectData.getProductData(productInfo),
                    look: imObjectData.getLookData(data.refLook, data.refBundle)
                }
            };
            return dataObject;
        }

        function eventSelectSize(product, selectedSize, colorIndex) {
            imProductDataService
                .getProductInfo(product, null, product.activeDetail.colors[colorIndex].id, selectedSize.sku)
                .then(function (productInfo) {
                    if (!window.imAnalytics.isFitSize) {
                        var action = 'seleccionar_talla';
                        if (selectedSize.visibility === 'coming_soon') {
                            action = 'ver_coming_soon';
                        } else if (selectedSize.visibility === 'back_soon') {
                            action = 'ver_back_soon';
                        }
                        var dataObject = getData(productInfo, action, '-talla_');
                        sendEvent([dataObject]);
                    } else {
                        //tema widgetFitAnalytics
                        window.imAnalytics.isFitSize = undefined;
                    }
                });
        }

        function eventSocialShare(product, social) {
            var category;
            switch (inditex.iPage) {
                case 'ItxCategoryPage':
                    if (isProductDialog()) {
                        category = 'vista_rapida_producto';
                        if (isLookbook()) {
                            category = 'lookbook_vista_rapida_producto';
                        }
                    } else {
                        category = 'lookbook';
                    }
                    break;

                case 'ItxProductPage':
                    if (isProductDialog()) {
                        if (imDataService.isBundle(product)) {
                            category = 'bundle_vista_rapida_producto';
                        } else {
                            category = 'vista_rapida_producto_cross';
                        }
                    } else {
                        category = 'ficha_producto';
                    }
                    break;

                case 'ItxShopCartPage':
                    category = 'cesta_vista_rapida_producto';
                    if (product.isRelated) {
                        category = 'cesta_vista_rapida_producto_cross';
                    }
                    break;

                case 'ItxCheckoutPage':
                    category = 'resumen_vista_rapida_producto';
                    break;
            }
            if (product) {
                imProductDataService.getProductInfo(product).then(function (productInfo) {
                    var dataObject = {
                        eventData: imObjectData.getEventData('social', category, 'compartir_'.concat(social), productInfo.partNumberColor),
                        customData: { product: imObjectData.getProductData(productInfo) }
                    };
                    sendEvent([dataObject]);
                });
            } else {
                var dataObject;
                if (document.getElementsByClassName('lookbook-page').length > 0) {
                    dataObject = {
                        eventData: imObjectData.getEventData(
                            'social',
                            category,
                            'compartir_'.concat(social),
                            inditex.iCategoryJSON ? inditex.iCategoryJSON.nameEn : undefined
                        )
                    };
                } else {
                    dataObject = {
                        eventData: imObjectData.getEventData('social', 'footer', 'ir_a_'.concat(social))
                    };
                }
                sendEvent([dataObject]);
            }
        }

        function eventStoreStock(product, selectedColorIndex) {
            imProductDataService.getProductInfo(product, null, selectedColorIndex).then(function (productInfo) {
                var eventDataObject = getData(productInfo);
                var label = productInfo.partNumberColor;
                if (typeof eventDataObject.customData.look.lookReference !== 'undefined') {
                    label = eventDataObject.customData.look.lookReference + '-' + productInfo.partNumberColor;
                }
                var dataObject = {
                    eventData: imObjectData.getEventData(
                        'disponibilidad_en_tienda',
                        eventDataObject.eventData.category,
                        'ver_disponibilidad_tienda',
                        label
                    ),
                    customData: {
                        product: imObjectData.getProductData(productInfo)
                    }
                };
                sendEvent([dataObject]);
            });
        }

        function eventProductInfo(product, activeSection) {
            var action;

            imProductDataService.getProductInfo(product, null).then(function (productInfo) {
                var dataObject;
                var data;
                switch (activeSection) {
                    case 'send':
                        action = 'ver_envio';
                        data = getData(productInfo, action);
                        break;
                    case 'returns':
                        action = 'ver_devolucion';
                        data = getData(productInfo, action);
                        break;
                    case 'cares':
                        action = 'ver_cuidados';
                        data = getData(productInfo, action);

                        var lab = productInfo.partNumberColor;

                        if (typeof data.customData.look.lookReference !== 'undefined') {
                            lab = data.customData.look.lookReference + '-' + productInfo.partNumberColor;
                        }
                        dataObject = {
                            eventData: imObjectData.getEventData('ayuda', data.eventData.category, 'ver_composicion', lab)
                        };
                        sendEvent([dataObject]);
                        break;
                }
                var label = productInfo.partNumberColor;
                if (typeof data.customData.look.lookReference !== 'undefined') {
                    label = data.customData.look.lookReference + '-' + productInfo.partNumberColor;
                }
                dataObject = {
                    eventData: imObjectData.getEventData('ayuda', data.eventData.category, action, label)
                };

                sendEvent([dataObject]);
            });
        }

        function goToShoppingCart() {
            var dataObject = {
                eventData: imObjectData.getEventData('checkout', getEventCategory(), 'tramitar_pedido')
            };
            sendEvent([dataObject]);
        }

        function eventAddToCart(product, isFitAnalytics = null) {
            var color = product.state.selectedColor;
            var size = product.state.selectedSize;
            var ecomerceObject = ADD_CART;
            ecomerceObject.ecommerce.currencyCode = imCommonService.replaceValue(
                ecomerceObject.ecommerce.currencyCode,
                imDataService.getCurrencyCode()
            );
            imProductDataService.getProductInfo(product, null, color.id, size.sku).then(function (infoObject) {
                var dimension156 = '';
                if (inditex.iUserJSON && inditex.iUserJSON.shopCart) {
                    dimension156 = inditex.iUserJSON.shopCart.id;
                }
                var productObject = [
                    {
                        name: infoObject.name,
                        id: infoObject.id,
                        key: infoObject.key,
                        category: infoObject.category,
                        quantity: 1,
                        dimension91: 'no_se_usa',
                        dimension96: infoObject.color,
                        dimension97: infoObject.size,
                        dimension99: infoObject.dimension99,
                        dimension100: infoObject.dimension100,
                        dimension101: infoObject.dimension101,
                        dimension117: infoObject.dimension117,
                        dimension109: infoObject.section,
                        dimension111: infoObject.family,
                        dimension113: infoObject.subfamily,
                        dimension146: imProductDataService.getLastSearchFromCookies(),
                        dimension156: dimension156,
                        price: infoObject.price,
                        partNumber: infoObject.partNumber,
                        talla: infoObject.size,
                        color: infoObject.color,
                        productState: infoObject.productState,
                        claseProducto: infoObject.claseProducto,
                        isRelated: infoObject.isRelated,
                        gridElemType: infoObject.gridElemType,
                        dimension29: infoObject.isCustomizable
                    }
                ];
                if (isFitAnalytics == true) {
                    productObject[0].dimension91 = 'hizo_caso';
                } else if (isFitAnalytics == false) {
                    productObject[0].dimension91 = 'no_hizo_caso';
                }

                ecomerceObject.ecommerce.add.products = imCommonService.replaceProduct(ecomerceObject.ecommerce.add.products, productObject);

                var dataObject;
                dataObject = getData(infoObject, isFitAnalytics);
                if (
                    inditex.iPage === 'ItxProductPage' ||
                    (inditex.iPage === 'ItxShopCartPage' && !isSaveForLaterTab()) ||
                    (isSaveForLaterTab() && isProductDialog())
                ) {
                    ecomerceObject.ecommerce.add.actionField.list = undefined;
                } else if (inditex.iPage === 'ItxShopCartPage' && isSaveForLaterTab() && !isProductDialog()) {
                    ecomerceObject.ecommerce.add.actionField.list = 'cesta_productos_guardados';
                } else {
                    ecomerceObject.ecommerce.add.actionField.list = imDataService.getList(infoObject);
                }
                imEventService.analyticsEvent(dataObject, ecomerceObject);
            });

            function getDataFromCategory(infoObject) {
                var category, action, lookReference;
                var label = infoObject.partNumber;
                var refBundle;
                action = 'anadir_producto_cesta';
                if (isLookbook()) {
                    if (isProductDialog()) {
                        category = 'lookbook_vista_rapida_producto';
                    } else {
                        category = 'ficha_look';
                    }
                    lookReference = inditex.getSessionStorage('lookRef');
                    label = lookReference + '-' + infoObject.partNumber;
                } else {
                    category = 'parrilla';
                    if (isProductDialog()) {
                        category = 'vista_rapida_producto';
                    } else if (imDataService.isBundle()) {
                        category = 'vista_rapida_bundle';
                        refBundle = imDataService.getBundleRef() + '-';
                        label = refBundle + label;
                    }
                }

                return {
                    category: category,
                    action: action,
                    lookReference: lookReference,
                    label: label
                };
            }

            function getDataFromProduct(infoObject, isFitAnalytics = null) {
                var category, action, lookReference;
                var label = infoObject.partNumber;
                var refBundle;

                if (isProductDialog()) {
                    category = 'vista_rapida_producto_cross';
                    action = 'anadir_producto_cesta';
                    if (imDataService.isBundle(infoObject)) {
                        category = 'bundle_vista_rapida_producto';
                        refBundle = inditex.getSessionStorage('bundleRef') + '-';
                        label = refBundle + label;
                    }
                } else {
                    category = isFitAnalytics !== null ? 'recomendador_tallas' : 'ficha_producto';
                    action = 'anadir_producto_cesta';
                    if (imDataService.isBundle(infoObject)) {
                        category = 'ficha_bundle';
                        action = 'anadir_producto_cesta';
                        refBundle = inditex.getSessionStorage('bundleRef') + '-';
                        label = refBundle + label;
                    }
                }

                return {
                    category: category,
                    action: action,
                    lookReference: lookReference,
                    bundleReference: refBundle,
                    label: label
                };
            }

            function getDataFromCart(infoObject) {
                var category, action, lookReference;
                var label = infoObject.partNumber;

                if (infoObject.isRelated && !isProductDialog() && !isSaveForLaterTab()) {
                    category = 'cesta';
                    action = 'anadir_producto_cross_cesta';
                } else if (infoObject.isRelated && isProductDialog()) {
                    category = 'cesta_vista_rapida_producto_cross';
                    action = 'anadir_producto_cesta';
                } else if (!infoObject.isRelated && !isSaveForLaterTab()) {
                    category = 'cesta_vista_rapida_producto';
                    action = 'anadir_producto_cesta';
                } else if (isSaveForLaterTab()) {
                    category = 'cesta';
                    action = 'anadir_producto_guardado_cesta';
                }
                return {
                    category: category,
                    action: action,
                    lookReference: lookReference,
                    label: label
                };
            }

            function getData(infoObject, isFitAnalytics = null) {
                var data = {};
                var page = inditex.iPage;
                if (imDataService.isHome()) {
                    page = 'ItxHomePage';
                }
                switch (page) {
                    case 'ItxCategoryPage':
                        data = getDataFromCategory(infoObject);
                        break;
                    case 'ItxProductPage':
                        data = getDataFromProduct(infoObject, isFitAnalytics);
                        break;
                    case 'ItxShopCartPage':
                        data = getDataFromCart(infoObject);
                        break;
                    case 'ItxCheckoutPage':
                        data = {
                            category: 'resumen_vista_rapida_producto',
                            action: 'anadir_producto_cesta',
                            label: infoObject.partNumber,
                            lookReference: undefined
                        };
                    case 'ItxHomePage':
                        data = {
                            category: 'home' + imObjectData.getSection(),
                            action: 'anadir_producto_cesta',
                            label: infoObject.partNumber
                        };
                        if (isPopupHomeBundle()) {
                            data = {
                                category: 'vista_rapida_bundle',
                                action: 'anadir_producto_cesta',
                                label: infoObject.partNumber
                            };
                        }
                        var bundleRef = imDataService.getBundleRef();
                        if (bundleRef) {
                            data.label = bundleRef + '-' + infoObject.partNumber;
                            data.bundleReference = bundleRef;
                        }
                        break;
                }
                if (imDataService.isSearch()) {
                    //Eventos buscador
                    data.category = 'buscador';
                    data.action = 'anadir_producto_cesta';
                    data.label = infoObject.partNumber;
                }
                var dataObject = {
                    eventData: imObjectData.getEventData('checkout', data.category, data.action, data.label),
                    customData: {
                        product: imObjectData.getProductData(infoObject),
                        look: imObjectData.getLookData(data.lookReference, data.bundleReference)
                    }
                };
                return [dataObject];
            }
        }

        function eventRelatedProductClick(product, relatedType, page, linkType, place) {
            var ecomerceObject = PRODUCT_CLICK;
            var list = getRelatedList(relatedType, place, product);
            linkType = 'foto';
            inditex.setSessionStorage('imList', list);

            var selectedColorIndex = (product.state && product.state.selectedColorIndex) || 0;
            ecomerceObject.ecommerce.currencyCode = imCommonService.replaceValue(
                ecomerceObject.ecommerce.currencyCode,
                imDataService.getCurrencyCode()
            );
            ecomerceObject.ecommerce.click.actionField.list = imCommonService.replaceValue(ecomerceObject.ecommerce.click.actionField.list, list);
            imProductDataService.getProductInfo(product, null, selectedColorIndex).then(function (productInfo) {
                var dataObject = getRelatedProductData(productInfo, page, linkType);
                var productObject = [
                    {
                        name: productInfo.name,
                        id: productInfo.id,
                        category: productInfo.category,
                        position: typeof position !== 'undefined' ? parseInt(position) + 1 : undefined,
                        dimension96: productInfo.color || productInfo.dimension96,
                        dimension99: productInfo.dimension99,
                        dimension100: productInfo.dimension100,
                        dimension101: productInfo.dimension101,
                        dimension117: productInfo.dimension117,
                        dimension109: productInfo.section || productInfo.dimension109,
                        dimension111: productInfo.family || productInfo.dimension111,
                        dimension113: productInfo.subfamily || productInfo.dimension113,
                        dimension146: imProductDataService.getLastSearchFromCookies(),
                        price: productInfo.price,
                        partNumberColor: productInfo.partNumberColor,
                        key: productInfo.key,
                        dinension29: productInfo.isCustomizable
                    }
                ];

                ecomerceObject.ecommerce.click.products = imCommonService.replaceProduct(ecomerceObject.ecommerce.click.products, productObject);

                imEventService.analyticsEvent([dataObject], ecomerceObject);
            });
        }
        function getRelatedList(relatedType, place, product) {
            var pageType = {
                ItxCategoryPage: 'parrilla',
                ItxHomePage: 'home',
                ItxHomeBgPage: 'home',
                ItxHomeMenPage: 'home',
                ItxHomeWomenPage: 'home',
                ItxProductPage: 'ficha_producto',
                ItxSearchPage: 'buscador',
                ItxShopCartPage: 'cesta'
            };
            var pageLocation = pageType[inditex.iPage] ? pageType[inditex.iPage] : '';
            if (imDataService.isRelatedProductDialog() || (imDataService.isProductDialog() && place === 'CS_BS')) {
                pageLocation += '/popup';
            }
            var placeType = {
                ADD_CART: '/addtocart',
                CS_BS: '/bs'
            };
            pageLocation += placeType[place] ? placeType[place] : '';
            let partNumberColor = '';
            if (product.state && product.detail && product.detail.reference && product.state.selectedColor && product.state.selectedColor.id) {
                partNumberColor = '_' + imProductDataService.getPartNumberColor(product.detail.reference, product.state.selectedColor.id);
            }
            var listType = {
                RECENTLY_VIEWED: 'ultimosvistos_' + pageLocation + partNumberColor,
                RELATED: 'relacionados_' + pageLocation + '_similares' + partNumberColor,
                COMPLETE_LOOK: 'relacionados_' + pageLocation + '_completatulook' + partNumberColor,
                RELATED_BUYED: 'relacionados_' + pageLocation + '_tickets' + partNumberColor
            };
            var list = listType[relatedType] || 'relacionados_' + pageLocation + partNumberColor;
            var cartTab = angular.element('.group-items-tab.active');
            if (cartTab.length > 0 && cartTab.attr('ng-click') && cartTab.attr('ng-click').indexOf('showBuylater') > -1) {
                list += '/compramastarde';
            }
            return list;
        }

        function getRelatedProductData(productInfo, page, linktype) {
            var location = imDataService.location(page);
            var info = {
                ItxProductPage: {
                    cf: 'catalogo',
                    category: 'ficha_producto',
                    action: 'ver_producto_cross',
                    label: productInfo.partNumberColor
                },
                ItxCategoryPage: {
                    cf: 'catalogo',
                    category: 'parrilla',
                    action: 'ver_producto_cross',
                    label: productInfo.partNumberColor
                },
                ItxShopCartPage: {
                    cf: 'checkout',
                    category: 'cesta',
                    action: 'ver_vista_rapida_producto_cross',
                    label: productInfo.partNumberColor
                }
            };
            var eventData = info[location]
                ? info[location]
                : {
                    cf: 'catalogo',
                    category: 'productos_relacionados',
                    action: 'ver_producto_cross',
                    label: productInfo.partNumberColor
                };

            var dataObject = {
                eventData: eventData,
                customData: {
                    photo: imObjectData.getPhotoData(linktype),
                    category: imObjectData.getCategoryData(productInfo),
                    product: imObjectData.getProductData(productInfo)
                }
            };
            return dataObject;
        }

        function sendEvent(eventData) {
            imEventService.analyticsEvent(eventData);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('imAnalytics')
        .service('imImpressionService', [
            'DEBUG',
            'IMPRESSIONS',
            '$q',
            'imEventService',
            'imDataService',
            'imCommonService',
            'imProductDataService',
            'imObjectData',
            imImpressionService
        ]);

    function imImpressionService(DEBUG, IMPRESSIONS, $q, imEventService, imDataService, imCommonService, imProductDataService, imObjectData) {
        return {
            sendImpression: sendImpression,
            resendPageview: resendPageview
        };

        function parseProduct(product, position, list, colorIndex) {
            if (typeof position === 'number') {
                //Position start in 0.
                position++;
            }

            if (list != "'parrilla'") {
                list = imDataService.getList(product);
            } else {
                list = imDataService.getCategoryTypes();
            }

            var promise = function (resolve) {
                imProductDataService.getProductInfo(product, null, colorIndex).then(function (infoObject) {
                    var productObject = {
                        name: infoObject.name,
                        id: infoObject.id,
                        category: infoObject.category,
                        position: position,
                        dimension96: infoObject.color,
                        dimension99: infoObject.dimension99,
                        dimension100: infoObject.dimension100,
                        dimension101: infoObject.dimension101,
                        dimension117: infoObject.dimension117,
                        dimension109: infoObject.section,
                        dimension111: infoObject.family,
                        dimension113: infoObject.subfamily,
                        dimension146: imProductDataService.getLastSearchFromCookies(),
                        price: infoObject.price,
                        list: list,
                        key: infoObject.key,
                        dimension29: infoObject.isCustomizable
                    };
                    resolve(productObject);
                });
            };

            return $q(promise);
        }

        function sendImpression(scope, isImpression) {
            var ecommerceObject = IMPRESSIONS;
            ecommerceObject.ecommerce.currencyCode = imDataService.getCurrencyCode();
            DEBUG(scope.elements);
            var promises = scope.elements.map(function (elementInfo) {
                return parseProduct(elementInfo.product, elementInfo.position, scope.list, elementInfo.colorIndex);
            });

            $q.all(promises).then(function (productArray) {
                DEBUG(productArray);
                var productsArray = _.uniqBy(productArray, 'id');
                DEBUG(productsArray);
                ecommerceObject.ecommerce.impressions = imCommonService.replaceImpression(ecommerceObject.ecommerce.impressions, productsArray);
                if (document.getElementsByClassName('bundle-product-page').length <= 0) {
                    var dataObject = getData(scope, productsArray);

                    if (isImpression && window.imAnalytics.isImpression) {
                        imEventService.impression([dataObject], ecommerceObject);
                    } else if (!scope.isSearch || !imDataService.isSearch()) {
                        inditex.setSessionStorage('dataObject', JSON.stringify(dataObject));
                        inditex.setSessionStorage('ecommerceObject', JSON.stringify(ecommerceObject));
                        window.imAnalytics.isImpression = true;
                        if (scope.list !== "'parrilla'" || $('.has-search').length <= 0 || $('.ebx-empathy-x--opened').length <= 0) {
                            imEventService.pageView([dataObject], ecommerceObject);
                        }
                    } else {
                        inditex.setSessionStorage('dataSearchObject', JSON.stringify(dataObject));
                        inditex.setSessionStorage('ecommerceSearchObject', JSON.stringify(ecommerceObject));
                        imEventService.pageView([dataObject], ecommerceObject);
                        window.imAnalytics.isImpression = true;
                    }
                }
            });
        }

        function resendPageview(localStoredSearch) {
            var ecommerceObject, dataObject;
            if (localStoredSearch) {
                ecommerceObject = inditex.getSessionStorage('ecommerceSearchObject') || '{}';
                dataObject = inditex.getSessionStorage('dataSearchObject') || JSON.stringify(getData());
            } else {
                ecommerceObject = inditex.getSessionStorage('ecommerceObject') || '{}';
                dataObject = inditex.getSessionStorage('dataObject') || JSON.stringify(getData());
            }
            ecommerceObject = JSON.parse(ecommerceObject);
            dataObject = JSON.parse(dataObject);

            imEventService.pageView([dataObject], ecommerceObject);
        }

        function getData(scope, productsArray) {
            scope = scope || {};
            productsArray = productsArray || [];
            var dataObject = {};
            if (scope.list != "'parrilla'" && (scope.search || imDataService.isSearch())) {
                dataObject = {
                    page: imObjectData.getPageData(
                        null,
                        'catalogo',
                        'buscador',
                        'resultados/lista?q=' + (scope.term || window.imAnalytics.imSearchTerm)
                    ),
                    user: imObjectData.getUserData(),
                    context: imObjectData.getContextData(),
                    searchEngine: imObjectData.getSearchData(scope.term, scope.number)
                };
            } else if (scope.list === 'lookbook') {
                dataObject = {
                    category: productsArray[0] ? imObjectData.getCategoryData(productsArray[0]) : undefined,
                    page: imObjectData.getPageData(
                        null,
                        'catalogo',
                        'lookbook',
                        inditex.iCategoryJSON ? inditex.iCategoryJSON.nameEn + '/parrilla_looks' : '/parrilla_looks'
                    ),
                    user: imObjectData.getUserData(),
                    context: imObjectData.getContextData()
                };
            } else {
                var layoutExpanded = JSON.parse(inditex.getLocalStorage('LAYOUT_EXPANDED')) || false;
                dataObject = {
                    category: imObjectData.getCategoryPath(),
                    page: imObjectData.getPageData(null, 'catalogo', 'parrilla'),
                    user: imObjectData.getUserData(),
                    context: imObjectData.getContextData()
                };
                dataObject.category.viewType = layoutExpanded ? '4' : '2';
            }
            return dataObject;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('imAnalytics')
        .service('imGridService', [
            'imObjectData',
            'imEventService',
            'imProductService',
            'imProductDataService',
            'imEventServiceWrapper',
            imGridService
        ]);

    function imGridService(imObjectData, imEventService, imProductService, imProductDataService, imEventServiceWrapper) {
        return {
            sendPageView: sendPageView,
            sendProductEvent: sendProductEvent,
            sendClickBanner: sendClickBanner
        };

        function sendPageView(category, products) {
            var ecommerceObject, dataObject;
            var dataObject = getDataCategory(category);
            dataObject.category.itemsNumber = products ? products.length : 0;
            let consumerProduct = '';
            if (dataObject.category && dataObject.category.category) {
                consumerProduct = dataObject.category.category.toLowerCase();
            }
            dataObject.product = { consumerProduct };
            window.sessionStorage.setItem('imList', 'parrilla_' + dataObject.category.categoryPath);
            imEventService.pageView([dataObject], ecommerceObject);
        }

        function sendClickBanner(category) {
            var eventData = {
                cf: 'catalogo',
                category: 'parrilla',
                action: 'click_banner',
                label: imObjectData.getCategoryDataById(category).categoryPath,
                debugId: category
            };
            imEventServiceWrapper.sendCustomAnalytics(eventData);
        }

        function sendProductEvent(product, colorIndex) {
            var dataObject = {};
            if (product.isBundleBean) {
                imProductDataService.getBundleInfo(product).then(function (productInfo) {
                    dataObject = getEventData(productInfo, product);
                    var productObject = imProductService.parseEcommerceProduct(productInfo);
                    imProductService.productClick(dataObject, productObject);
                });
            } else {
                imProductDataService.getProductInfo(product, null, colorIndex, null).then(function (productInfo) {
                    dataObject = getEventData(productInfo);
                    var productObject = imProductService.parseEcommerceProduct([productInfo]);
                    imProductService.productClick(dataObject, productObject);
                });
            }
        }

        function getDataCategory(category) {
            var category = imObjectData.getCategoryPath(category);
            category.viewType = imObjectData.getViewType();
            var dataObject = {
                category: category,
                page: imObjectData.getPageData(null, 'catalogo', 'parrilla', category.categoryPath),
                user: imObjectData.getUserData(),
                context: imObjectData.getContextData()
            };
            return dataObject;
        }

        function getEventData(product, bundle) {
            var eventData = {
                cf: 'catalogo',
                category: 'parrilla',
                action: 'ver_producto',
                label: product.partNumberColor
            };
            var customData = {
                product: imObjectData.getProductData(product),
                category: {
                    season: product.season
                }
            };
            var dataObject = {
                eventData: eventData,
                customData: customData
            };
            if (bundle) {
                var refBundle = bundle.activeDetail.reference;
                eventData.action = 'ver_bundle';
                eventData.label = refBundle;
                customData.look = imObjectData.getLookData(undefined, refBundle);
                return dataObject;
            }
            if (imProductService.isLookbook()) {
                eventData.category = 'ficha_look';
                var refLook = inditex.getSessionStorage('lookRef') || '';
                eventData.label = refLook + '-' + eventData.label;
                customData.look = imObjectData.getLookData(refLook);
                return dataObject;
            }
            return dataObject;
        }
    }
})();

(function () {
    'use strict';

    angular.module('imAnalytics').service('imDataService', ['imObjectData', imDataService]);

    function imDataService(imObjectData) {
        return {
            getCurrencyCode: getCurrencyCode,
            getList: getList,
            isHome: isHome,
            getCategoryTypes: getCategoryTypes,
            isSearch: isSearch,
            isProductDialog: isProductDialog,
            isRelatedProductDialog: isRelatedProductDialog,
            isLookbook: isLookbook,
            isBundle: isBundle,
            isSearchRecommendation: isSearchRecommendation,
            whereAre: whereAre,
            location: location,
            getBundleRef: getBundleRef,
            setBundleRef: setBundleRef
        };

        function getCurrencyCode() {
            var currencyCode;
            if (inditex && 'iStoreJSON' in inditex && 'details' in inditex.iStoreJSON && 'locale' in inditex.iStoreJSON.details) {
                currencyCode = inditex.iStoreJSON.details.locale.currencyCode;
            }
            return currencyCode;
        }
        function isHome() {
            var homes = {
                ItxHomePage: true,
                ItxHomeBgPage: true,
                ItxHomeWomenPage: true,
                ItxHomeMenPage: true
            };
            return homes[inditex.iPage];
        }

        function isSearch() {
            return angular.element('.has-search').length > 0 || angular.element('.ebx-empathy-x--opened').length > 0;
        }

        function isProductDialog() {
            return angular.element('.ngdialog.ma-dialog').length > 0;
        }

        function isRelatedProductDialog() {
            return angular.element('itx-related-product-dialog').length > 0;
        }

        function isLookbook() {
            return document.getElementById('lookbook') ? true : false;
        }

        function isBundle(product) {
            product = product || {};
            return product.gridElemType == 'BUNDLE' ? true : false || angular.element('.ma-product-bundle-container').length > 0;
        }
        function getBundleRef() {
            return inditex.getSessionStorage('imBundleRef');
        }
        function setBundleRef(value) {
            inditex.setSessionStorage('imBundleRef', value);
        }

        function isSearchRecommendation() {
            return angular.element('.ebx-recommendations').length > 0;
        }

        function location(page) {
            var pageKind = page || inditex.iPage;
            pageKind = isLookbook() ? 'ItxLookBookPage' : pageKind;
            //pageKind = isBundle() ? 'ItxBundlePage' : pageKind;
            pageKind = isSearch() ? 'ItxSearchPage' : pageKind;
            if (isProductDialog()) {
                return pageKind + 'ProductDialog';
            }
            if (isRelatedProductDialog()) {
                return pageKind + 'RelatedProductDialog';
            }
            return pageKind;
        }

        //TODO REFACTOR
        function whereAre() {
            var isPopup = isProductDialog();
            var pageKind = inditex.iPage;
            pageKind = isLookbook() ? 'ItxLookBookPage' : pageKind;
            //pageKind = isBundle() ? 'ItxBundlePage' : pageKind;
            pageKind = isSearch() ? 'ItxSearchPage' : pageKind;
            pageKind = isHome() ? 'ItxHomePage' : pageKind;
            //falta casuistica bundle
            switch (pageKind) {
                case 'Itx410ErrorPage':
                    return isPopup ? 'vista_rapida_producto_error_page' : 'error_page';
                    break;
                case 'ItxCategoryPage':
                    return isPopup ? 'vista_rapida_producto_category_page' : 'category_page';
                    break;
                case 'ItxCheckoutPage':
                    return isPopup ? 'vista_rapida_producto_checkout_page' : 'chekout_page';
                    break;
                case 'ItxGuestAccountPage':
                    return isPopup ? 'vista_rapida_producto_guest_account_page' : 'guest_account_page';
                    break;
                case 'ItxHomepage':
                    return isPopup ? 'vista_rapida_producto_home_page' : 'home_page';
                    break;
                case 'ItxMyAccountPage':
                    return isPopup ? 'vista_rapida_producto_account_page' : 'account_page';
                    break;
                case 'ItxOrderConfirmationPage':
                    return isPopup ? 'vista_rapida_producto_confirmation_page' : 'confirmation_page';
                    break;
                case 'ItxOrderRepaymentPage':
                    return isPopup ? 'vista_rapida_producto_repayment_page' : 'repayment_page';
                    break;
                case 'ItxProductPage':
                    //las vistas rápidas de hoy en esta página son de productos relacionados.
                    return isPopup ? 'vista_rapida_producto_product_page' : 'product_page';
                    break;
                case 'ItxBundlePage':
                    return isPopup ? 'vista_rapida_producto_bundle_page' : 'bundle_page';
                    break;
                case 'ItxSearchPage':
                    return isPopup ? 'vista_rapida_producto_search_page' : 'search_page';
                    break;
                case 'ItxLookBookPage':
                    return isPopup ? 'vista_rapida_producto_lookbook_page' : 'lookbook_page';
                    break;
                case 'ItxShopCartPage':
                    return isPopup ? 'vista_rapida_producto_shop_cart_page' : 'shop_cart_page';
                    break;
                case 'ItxWorldWidePage':
                    return isPopup ? 'vista_rapida_producto_world_wide_page' : 'world_wide_page';
                    break;
            }
        }

        function getList(product) {
            var list = window.sessionStorage.getItem('imList');
            if (window.imAnalytics && window.imAnalytics.workAround) {
                return window.imAnalytics.workAround;
            }
            if (list === 'minicesta') {
                window.sessionStorage.removeItem('imList');
                return undefined;
            }
            if ((inditex.iPage === 'ItxShopCartPage' && product && !product.isRelated) || inditex.iPage === 'ItxCheckoutPage') {
                return undefined;
            }
            if (isSearch()) {
                return 'buscador';
            }
            if (isProductDialog()) {
                return undefined;
            }
            if (isHome()) {
                return 'home' + imObjectData.getSection();
            }
            if (
                (document.referrer.match(/.*-(c1831519).*/) && inditex.iPage === 'ItxProductPage') ||
                document.location.pathname.match(/.*-(c1831519).*/)
            ) {
                return 'curalate';
            }
            var iPage = inditex.iPage;
            if (window.imAnalytics && window.imAnalytics.angular && window.imAnalytics.angular != '') {
                iPage = window.imAnalytics.angular;
                window.imAnalytics.angular = '';
            }
            if (!list || iPage != 'ItxProductPage') {
                if (
                    window.document.referrer.indexOf('massimodutti') === -1 &&
                    iPage !== 'ItxCategoryPage' &&
                    !('categoryJSON' in imAnalytics) &&
                    performance.navigation.type !== 1
                ) {
                    return 'directo';
                } else {
                    return getCategoryTypes();
                }
            }

            return list;
        }

        function getCategoryTypes() {
            var cat = inditex || '';
            cat = inditex.iCategoryJSON;
            var types = {
                1: 'lookbook_',
                17: 'lookbook_',
                26: 'lookbook_',
                2: 'subhome_',
                5: 'subhome_',
                45: 'microsite_',
                44: 'microsite_'
            };
            if (cat) {
                var list = types[inditex.iCategoryJSON.type] || 'parrilla_';
                var catPath = imObjectData.getCategoryPath();
                return list + catPath.categoryPath;
            } else {
                return 'desconocida';
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('imAnalytics')

        .service('imCartService', [
            'ADD_CART',
            'REMOVE_CART',
            'imProductDataService',
            'imCommonService',
            'imDataService',
            'imEventService',
            'imObjectData',
            'imCheckoutService',
            imCartService
        ]);

    function imCartService(
        ADD_CART,
        REMOVE_CART,
        imProductDataService,
        imCommonService,
        imDataService,
        imEventService,
        imObjectData,
        imCheckoutService
    ) {
        return {
            itemQuantityChange: itemQuantityChange,
            itemSizeChange: itemSizeChange,
            saveForLater: saveForLater
        };

        // TODO: Esto se puede refactorizar, y juntar las dos funciones con un boolean, true añadir y false eliminar
        function itemQuantityChange(item, quantity) {
            var action = '';
            if (quantity === 0) {
                action = 'eliminar';
            } else if (quantity < item.quantity) {
                action = 'decrementar';
            } else {
                action = 'incrementar';
            }
            imProductDataService.getProductInfoCart(item, quantity).then(function (productInfo) {
                var dataObject = {
                    eventData: imObjectData.getEventData('checkout', 'cesta', action, productInfo.partNumber),
                    customData: {
                        product: imObjectData.getProductData(productInfo),
                        cart: imObjectData.getCartData(item)
                    }
                };
                delete productInfo.position;
                delete productInfo.partNumber;
                if (action === 'decrementar' || action === 'eliminar') {
                    productInfo.quantity = item.quantity - quantity;
                    remove([dataObject], imDataService.getCurrencyCode(), [productInfo], 'itemQuantityChange');
                    var cartShop = JSON.parse(inditex.getLocalStorage('cache-shop-cart')) || [];
                    if (quantity === 0 && cartShop.items.length <= 1) {
                        cartShop.items = [];
                        imCheckoutService.createCartShop(cartShop, 1);
                    }
                } else {
                    productInfo.quantity = quantity - item.quantity;
                    add([dataObject], imDataService.getCurrencyCode(), [productInfo], 'itemQuantityChange');
                }
            });
        }

        function itemSizeChange(item, sku) {
            imProductDataService.getProductInfoCart(item).then(function (productInfo) {
                var dataObject = {
                    eventData: imObjectData.getEventData('checkout', 'cesta', 'eliminar', productInfo.partNumber),
                    customData: {
                        product: imObjectData.getProductData(productInfo),
                        cart: imObjectData.getCartData(item)
                    }
                };
                remove([dataObject], imDataService.getCurrencyCode(), [productInfo], 'itemQuantityChange');
            });
        }

        function saveForLater(item, quantity) {
            var size = item.state.selectedSize ? item.state.selectedSize.sku : null;
            imProductDataService.getProductInfo(item, quantity, null, size).then(function (productInfo) {
                var action = '';
                if (quantity === 0) {
                    action = 'eliminar_producto_guardado';
                } else {
                    action = 'guardar_producto';
                }
                var dataObject = {
                    eventData: imObjectData.getEventData('checkout', 'cesta', action, productInfo.partNumber),
                    customData: {
                        product: imObjectData.getProductData(productInfo)
                    }
                };
                delete productInfo.position;
                delete productInfo.partNumber;
                if (action === 'guardar_producto') {
                    remove([dataObject], imDataService.getCurrencyCode(), [productInfo], 'saveForLater');
                    var cartShop = JSON.parse(inditex.getLocalStorage('cache-shop-cart')) || [];
                    if (cartShop.items.length <= 1) {
                        cartShop.items = [];
                        imCheckoutService.createCartShop(cartShop, 1);
                    }
                } else {
                    imEventService.analyticsEvent([dataObject]);
                }
            });
        }

        /**
         * PRIVATE FUNCTIONS
         */

        function add(data, currencyCode, product, functionName) {
            var ecomerceObject = ADD_CART;
            ecomerceObject.ecommerce.currencyCode = imCommonService.replaceValue(ecomerceObject.ecommerce.currencyCode, currencyCode);
            ecomerceObject.ecommerce.add.products = imCommonService.replaceProducts(ecomerceObject.ecommerce.add.products, product);
            if (functionName === 'saveForLater') {
                ecomerceObject.ecommerce.add.actionField.list = 'cesta_productos_guardados';
            } else {
                ecomerceObject.ecommerce.add.actionField.list = undefined;
            }

            imEventService.analyticsEvent(data, ecomerceObject);
        }

        function remove(data, currencyCode, product, functionName) {
            var ecomerceObject = REMOVE_CART;
            ecomerceObject.ecommerce.currencyCode = imCommonService.replaceValue(ecomerceObject.ecommerce.currencyCode, currencyCode);
            ecomerceObject.ecommerce.remove.products = imCommonService.replaceProducts(ecomerceObject.ecommerce.remove.products, product);
            if (functionName === 'saveForLater') {
                ecomerceObject.ecommerce.remove.actionField.list = 'cesta_productos_guardados';
            } else {
                ecomerceObject.ecommerce.remove.actionField.list = undefined;
            }
            imEventService.analyticsEvent(data, ecomerceObject);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('imAnalytics')

        .service('imCheckoutService', [
            'CHECKOUT',
            '$q',
            'imCommonService',
            'imDataService',
            'imEventService',
            'imProductDataService',
            'imObjectData',
            'imEventServiceWrapper',
            imCheckoutService
        ]);

    function imCheckoutService(
        CHECKOUT,
        $q,
        imCommonService,
        imDataService,
        imEventService,
        imProductDataService,
        imObjectData,
        imEventServiceWrapper
    ) {
        return {
            sendCheckout: sendCheckout,
            createCartShop: createCartShop,
            createSummary: createSummary,
            selectWalletCard: selectWalletCard,
            checkoutEvent: checkoutEvent,
            saveForLaterPageview: saveForLaterPageview
        };

        function createCartShop(cartShop, step) {
            var itemsCartNumber = 0;
            if (typeof cartShop !== 'undefined' && cartShop.hasOwnProperty('items')) {
                itemsCartNumber = cartShop.items.length;
            }
            var dataObject = {
                cart: imObjectData.getCartData(cartShop.items),
                context: imObjectData.getContextData(),
                page: createPageName(step, itemsCartNumber),
                user: imObjectData.getUserData()
            };

            //Create promises, for all items on cart
            var promises = cartShop.items.map(function (item) {
                return imProductDataService.getProductInfoCart(item);
            });
            $q.all(promises).then(function (productInfo) {
                productInfo.map(function (item) {
                    delete item.position;
                });
                sendCheckout([dataObject], imDataService.getCurrencyCode(), step, productInfo);
            });
        }

        function saveForLaterPageview(step) {
            var dataObject = {
                context: imObjectData.getContextData(),
                page: createPageName(step),
                user: imObjectData.getUserData()
            };

            imEventService.pageView([dataObject]);

            //Create promises, for all items on cart
            /*var promises = buyLater.items.map(function (item) {
                return imProductDataService.getProductInfoCart(item);
            });
            $q.all(promises)
                .then(function (productInfo) {
                    productInfo.map(function (item) { delete item.position; });
                    sendCheckout([dataObject], imDataService.getCurrencyCode(), step, productInfo);
                });*/
        }

        function selectWalletCard(card) {
            var type = card ? card.paymentCodeName : '';
            var data = {
                cf: 'checkout',
                category: 'pago',
                action: 'seleccionar_pago_guardado',
                label: type.toLowerCase()
            };
            var customData = {
                order: {
                    payment: {
                        savedData: 'si'
                    }
                }
            };
            imEventServiceWrapper.sendCustomAnalytics(data, customData);
        }

        function createSummary(cartShop, store) {
            var dataObject = {
                cart: imObjectData.getCartData(cartShop.items),
                user: imObjectData.getUserData(),
                store: imObjectData.getStoreData(store),
                page: createPageName(4),
                context: imObjectData.getContextData()
            };
            dataObject.user.quickBuy = imObjectData.isQuickbuy();

            imEventService.pageView([dataObject]);
        }

        function sendCheckout(data, currencyCode, step, products) {
            var ecommerceObject = CHECKOUT;

            ecommerceObject.ecommerce.currencyCode = imCommonService.replaceValue(ecommerceObject.ecommerce.currencyCode, currencyCode);
            ecommerceObject.ecommerce.checkout.actionField.step = imCommonService.replaceValue(
                ecommerceObject.ecommerce.checkout.actionField.step,
                step
            );
            ecommerceObject.ecommerce.checkout.products = imCommonService.replaceProducts(ecommerceObject.ecommerce.checkout.products, products);

            imEventService.pageView(data, ecommerceObject);
        }

        function checkoutEvent(checkoutData) {
            var paymentType =
                checkoutData.ItxPaymentSvc.selected.kind.toLowerCase() === 'walletcard'
                    ? checkoutData.walletCard.paymentCodeName.toLowerCase()
                    : checkoutData.ItxPaymentSvc.selected.type.toLowerCase();
            var dataObject = {
                eventData: imObjectData.getEventData('checkout', 'resumen_compra', 'autorizar_pago', paymentType),

                customData: {
                    order: {
                        payment: {
                            gifticket: checkoutData.shopCart.giftTicket === '1' ? 'si' : 'no'
                        }
                    }
                }
            };

            imEventService.analyticsEvent([dataObject]);

            if (checkoutData.requireBill) {
                dataObject = {
                    eventData: imObjectData.getEventData('checkout', 'resumen_compra', 'solicitar_factura', null)
                };

                imEventService.analyticsEvent([dataObject]);
            }
        }

        /**
         * PRIVATE FUNCTIONS
         */
        function createPageName(step, itemsCartNumber) {
            var section = 'checkout';
            var context;
            if (step === 0) {
                context = imObjectData.getPageData(null, section, 'cesta', 'productos_guardados');
            } else if (step === 1 && itemsCartNumber === 0) {
                context = imObjectData.getPageData(null, section, 'cesta', 'vacia');
            } else if (step === 1 && itemsCartNumber !== 0) {
                context = imObjectData.getPageData(null, section, 'cesta', 'lista_de_productos');
            } else if (step === 2) {
                context = imObjectData.getPageData(null, section, 'envio', 'datos_envio');
            } else if (step === 3) {
                context = imObjectData.getPageData(null, section, 'pago', 'datos_pago');
            } else if (step === 4) {
                context = imObjectData.getPageData(null, section, 'resumen_compra', 'datos_pedido');
            }
            return context;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('imAnalytics')

        .service('imPurchaseService', [
            'PURCHASE',
            '$q',
            'imCommonService',
            'imEventService',
            'imDataService',
            'imProductDataService',
            'imObjectData',
            'imTrackingCommonService',
            'imEventServiceWrapper',
            'ItxUtilsFct',
            'Product',
            'DUTTI_CONS',
            'CommonServices',
            imPurchaseService
        ]);

    function imPurchaseService(
        PURCHASE,
        $q,
        imCommonService,
        imEventService,
        imDataService,
        imProductDataService,
        imObjectData,
        imTrackingCommonService,
        imEventServiceWrapper,
        ItxUtilsFct,
        Product,
        DUTTI_CONS,
        CommonServices
    ) {
        return {
            createPurchase: createPurchase,
            createPageViewPurchaseConfirmedGA4: createPageViewPurchaseConfirmedGA4,
            createPageHitPurchaseOrderEndZenit: createPageHitPurchaseOrderEndZenit,
            sendPurchaseAnalyticsToHero: _sendPurchaseAnalyticsToHero,
            createEvent: createEvent,
            createForm: createForm,
            createServer: createServer,
            downloadAppUrlAction: downloadAppUrlAction
        };

        function downloadAppUrlAction() {
            var dataObject = {
                eventData: imObjectData.getEventData('checkout', 'confirmacion', 'descarga_app', undefined)
            };
            sendEvent([dataObject]);
        }

        function createEvent(cf, action, label) {
            var dataObject = {
                eventData: imObjectData.getEventData(cf, 'confirmacion', action, label)
            };
            sendEvent([dataObject]);
        }

        function createForm(category, form) {
            imEventServiceWrapper.sendFormError('perfil_comprador', 'confirmacion', form);
        }

        function createServer(form, error) {
            imEventServiceWrapper.sendServerError('perfil_comprador', 'confirmacion', form, error);
        }

        function createPurchase(orderData) {
            var dataObject = {
                user: imObjectData.getUserData(),
                context: imObjectData.getContextData(),
                page: imObjectData.getPageData(null, 'checkout', 'confirmacion', 'datos_pedido'),
                order: imObjectData.getOrderData(orderData),
                cart: {
                    cartProducts: getKeyProducts(orderData.items)
                }
            };

            //Create promises, for all items on cart
            var promises = orderData.items.map(function (item) {
                return imProductDataService.getProductInfoCart(item);
            });

            $q.all(promises).then(function (productInfo) {
                productInfo.map(function (item) {
                    delete item.position;
                });
                var actionField = {
                    id: orderData.id,
                    shipping: orderData.shippingPrice ? inditex.formatNumber(orderData.shippingPrice) : 0,
                    revenue: inditex.formatNumber(orderData.totalOrder),
                    tax: inditex.formatNumber(orderData.tax)
                };
                sendPurchase([dataObject], imDataService.getCurrencyCode(), actionField, productInfo);
            });
        }

        function createPageViewPurchaseConfirmedGA4() {
            const userId = imObjectData.getUserId();
            const sha256 = imObjectData.getHashEmailSha256();
            const sha256_1 = sha256 ? sha256.slice(0, 36) : undefined;
            const sha256_2 = sha256 ? sha256.slice(36) : undefined;
            const dataObject = {
                event: 'page_view',
                ecommerce: undefined,
                eventData: undefined,
                user: {
                    im_user_email_sha256_1: sha256_1,
                    im_user_email_sha256_2: sha256_2,
                    im_user_id: userId,
                    im_store_id: imObjectData.getStoreId()
                },
                context: {
                    im_page_section: 'checkout',
                    im_page_type: 'confirmacion',
                    im_page_title: 'datos_pedido',
                    page_title: '/checkout/confirmacion/datos_pedido',
                    page_referrer: document.referrer,
                    user_id: userId,
                    im_user_email_sha256: sha256
                }
            }

            imEventService.pageViewGA4(dataObject);
        }

        function createPageHitPurchaseOrderEndZenit() {
            const dataObject = {
                records: [{
                    value: {
                        device: {
                            language: null,
                            name: null,
                            os: getOs(navigator.userAgent),
                            osVersion: getOsVersion(navigator.userAgent),
                            type: getType(window.innerWidth)
                        },
                        geo: getGeolocationData(),
                        utm: {
                            source: null,
                            medium: null,
                            campaign: null,
                            term: null,
                            content: null
                        },
                        eventName: 'PageHit',
                        payload: {
                            context: {
                                brandId: null,
                                displayLanguage: null,
                                pageType: 'PURCHASE_ORDER_END',
                                storeId: inditex.iStoreId
                            },
                            sessionId: getSessionId('ITXSESSIONID'),
                            timestamp: Date.now()
                        },
                        tenant: 'md',
                        'user-agent': {
                            appName: null,
                            appVersion: null,
                            platform: 'web',
                            uaString: null
                        },
                        'privacy-consent': {
                            consentedDate: getConsentedDate(),
                            consentCategories: getConsentCategories()
                        },
                        identity: getIdentity(),
                        version: '1.1.0'
                    }
                }]
            };
            imEventService.pageHitZenit(dataObject);
        }

        /**
         * Función para mandar analíticas de compra a Hero
         */
        function _sendPurchaseAnalyticsToHero(orderData) {
            // Define las analíticas de la compra
            const purchaseAnalytics = {
                id: orderData.id,
                subtotal: Number(orderData.totalProduct) / 100,
                currency: imDataService.getCurrencyCode(),
                total: Number(orderData.totalOrder) / 100,
                tax: orderData.tax,
                shippingCost: Number(orderData.shippingPrice) / 100,
                shippingMethod: orderData.shipping.kind,
                coupon: '??????????'
            };

            // Define las analíticas de los productos comprados
            var loopPromises = [];

            orderData.items.forEach(function (product) {
                // Añade las imágenes de los productos
                product.productImageUrls = ItxUtilsFct.getImageProductUrls(product, product.colorId, 'checkout', 'main', 'shopCart');

                // Creamos un nuevo producto a partir del Item para obtener la url de éste
                var newProduct = new Product(product.parentId, product.colorId);

                var deferred = $q.defer();

                loopPromises.push(deferred.promise);

                imProductDataService.getProductInfo(product, null, product.colorId).then(function (productInfo) {
                    const itemAnalytics = {
                        id: product.reference,
                        quantity: productInfo.quantity,
                        name: product.name,
                        image: product.productImageUrls[0].replace('http://', 'https://'),
                        price: Number(productInfo.price),
                        currency: imDataService.getCurrencyCode(),
                        brand: 'Massimo Dutti',
                        category: productInfo.category,
                        variant: `Color: ${product.color} - Size: ${product.size}`,
                        location: newProduct.getUrl()
                    };

                    deferred.resolve(itemAnalytics);
                });

                return deferred.promise;
            });

            $q.all(loopPromises).then(function (productsAnalytics) {
                // Al resolverse la consultas, manda la analítica a Hero
                if (hero && purchaseAnalytics && productsAnalytics) {
                    hero('track', {
                        type: 'ecommerce:purchase',
                        purchase: purchaseAnalytics,
                        products: productsAnalytics
                    });
                }
            });
        }

        /**
         * PRIVATE FUNCTIONS
         */
        function checkIdentityConditions() {
            return CommonServices.isCookieGroupAllowed(DUTTI_CONS.COOKIE_GROUPS.ANALYTICS) && inditex.iCountryCode !== 'CN' ? true : false;
        }

        function getIdentity() {
            let identity = {
                userId: null,
                token: null,
                kind: null
            };
            if (checkIdentityConditions()) {
                const userId = imObjectData.getUserId();
                identity.userId = userId ? userId.toString() : null;
            }

            return identity;
        }

        function getConsentCategories() {
            const info = window.OneTrust.GetDomainData();
            let consentCategories = '';
            info.Groups.forEach(function (group, index) {
                consentCategories += `${group.CustomGroupId}:${window.OptanonActiveGroups.includes(group.CustomGroupId) ? '1' : '0'}`;
                if (index !== Object.keys(info.Groups).length - 1) {
                    consentCategories += ',';
                }
            });

            return consentCategories || null;
        }

        function getCookie(cookies, cname) {
            const name = `${cname}=`;
            const decodedCookie = decodeURIComponent(cookies);
            const ca = decodedCookie.split(';');

            for (const c of ca) {
                let _c = c;
                while (_c.startsWith(' ')) {
                    _c = _c.substring(1);
                }
                if (_c.startsWith(name)) {
                    return _c.substring(name.length, _c.length);
                }
            }
            return null;
        }

        function getConsentedDate() {
            const cookieValue = getCookie(document.cookie, 'OptanonConsent');
            const propertyName = 'datestamp';

            if (cookieValue) {
                const properties = new URLSearchParams(cookieValue);
                const cookiePropertyValue = properties.get(propertyName);

                if (cookiePropertyValue) {
                    const regex = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{2}) (\d{4}) (\d{2}:\d{2}:\d{2}) (\w{3}) (\d{4}) \(.+\)/;
                    const match = regex.exec(cookiePropertyValue);

                    if (match) {
                        const [, dayOfWeek, month, day, year, time, , timezone] = match;

                        return `${dayOfWeek}, ${day} ${month} ${year} ${time}+${timezone}`;
                    }
                }
            }

            return null;
        }

        function getGeolocationData() {
            if (window.OneTrust !== undefined) {
                const geoData = window.OneTrust.getGeolocationData();

                return {
                    country: geoData.country || null,
                    region: geoData.state || null,
                };
            }
            return { country: null, region: null };
        }

        function getSessionId(cname) {
            let name = `${cname}=`;
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');

            for (let c of ca) {
                let _c = c;
                while (_c.startsWith(' ')) {
                    _c = _c.substring(1);
                }
                if (_c.startsWith(name)) {
                    return _c.substring(name.length, _c.length);
                }
            }
            return null;
        }

        function getOs(userAgent) {
            if (/(Android)\s(\S*)/.exec(userAgent)) return 'android';
            if (/(iPhone|iPod|iPod touch);/.exec(userAgent)) return 'ios';
            if (/(iPad;)/.exec(userAgent)) return 'ipados';
            if (/(Macintosh;)/.exec(userAgent)) return 'mac';
            if (/(Win64|Win32|Windows|Windows Phone\s(\S*));/.exec(userAgent)) return 'windows';
            if (/(WebOS;)/.exec(userAgent)) return 'android';
            if (/(Linux)\s(\S*)/.exec(userAgent)) return 'linux';
            return null;
        }

        function getOsVersion(userAgent) {
            const match = /(Android|iPhone|iPad|iPod|webOS|BlackBerry|Windows Phone|Windows|Mac OS X|CPU OS|Linux)\s\w*\s*\d(\w|\.)+/.exec(userAgent);
            if (match) {
                const version = match[0].split(' ');
                return version[version.length - 1];
            }
            return null;
        };

        function getType(width) {
            let device;

            if (width <= 767) {
                device = 'mobile';
            } else if (width > 767 && width < 992) {
                device = 'tablet';
            } else {
                device = 'desktop';
            }

            return device;
        }

        function sendPurchase(data, currencyCode, actionField, products) {
            var ecommerceObject = PURCHASE;
            ecommerceObject.ecommerce.currencyCode = imCommonService.replaceValue(ecommerceObject.ecommerce.currencyCode, currencyCode);
            ecommerceObject.ecommerce.purchase.actionField = imCommonService.deepmerge(ecommerceObject.ecommerce.purchase.actionField, actionField);
            ecommerceObject.ecommerce.purchase.products = imCommonService.replaceProducts(ecommerceObject.ecommerce.purchase.products, products);

            imEventService.pageView(data, ecommerceObject);
        }

        function getKeyProducts(items) {
            var products = [];
            for (var i = 0, len = items.length; i < len; i++) {
                products.push({
                    reference: items[i].reference,
                    quantity: items[i].quantity,
                    key: items[i].parentId
                });
            }
            return products;
        }

        function sendEvent(eventData) {
            imEventService.analyticsEvent(eventData);
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('imAnalytics')

        .service('imCategoryFilter', ['imEventServiceWrapper', imCategoryFilter]);

    function imCategoryFilter(imEventServiceWrapper) {
        return {
            createEvent: createEvent,
            deleteAttrFilter: deleteAttrFilter,
            deleteAllAttr: deleteAllAttr,
            deleteSize: deleteSize,
            deletePrice: deletePrice,
            deleteColor: deleteColor,
            deleteOrder: deleteOrder,
            applyOrder: applyOrder,
            applyAllAttr: applyAllAttr,
            applyColor: applyColor,
            applyPrice: applyPrice,
            applySize: applySize,
            changeView: changeView
        };

        function createEvent(action, label) {
            imEventServiceWrapper.sendBasicAnalytics('catalogo', 'parrilla', action, label);
        }

        function changeView(viewState, apollo = false) {
            if (apollo) {
                var numItems = 0;
                switch (viewState) {
                    case 1:
                        numItems = 1;
                        break;
                    case 2:
                        numItems = 4;
                        break;
                    case 3:
                        numItems = 12;
                        break;
                    default:
                        break;
                }
                createEventData('cambio_vista', numItems, numItems);
            } else {
                var isExpanded = JSON.parse(inditex.getLocalStorage('LAYOUT_EXPANDED')) || false;

                //Control para lanzar el evento solo en caso de cambio en la vista.
                if (isExpanded !== viewState) {
                    var num = isExpanded ? '4' : '2';
                    createEventData('cambio_vista', num, num);
                }
            }
        }

        function deleteAttrFilter(attr) {
            var filterTypes = {
                types: 'XTYPEFILTER',
                qualities: 'XCALFILTER',
                characteristics: 'XCATFILTER',
                colors: 'color',
                sizes: 'size',
                prices: 'price',
                order: 'order'
            };

            //attr.type = filterTypes[attr];
            var selectedFilters = JSON.parse(inditex.getSessionStorage('imCategoryFilters')) || [];
            var filterPosition = selectedFilters.indexOf(attr.value);
            if (filterTypes[attr.type] === 'XTYPEFILTER' || filterTypes[attr.type] === 'XCALFILTER' || filterTypes[attr.type] === 'XCATFILTER') {
                selectedFilters.splice(filterPosition, 1);
                inditex.setSessionStorage('imCategoryFilters', JSON.stringify(selectedFilters));
                imEventServiceWrapper.sendBasicAnalytics('catalogo', 'parrilla', 'limpiar_filtro', filterTypes[attr.type] + '-' + attr.value);
            } else if (filterTypes[attr.type] === 'color') {
                selectedFilters.splice(filterPosition, 1);
                inditex.setSessionStorage('imCategoryFilters', JSON.stringify(selectedFilters));
                imEventServiceWrapper.sendBasicAnalytics('catalogo', 'parrilla', 'limpiar_filtro', 'color-' + attr.value);
            } else if (filterTypes[attr.type] === 'size') {
                filterPosition = selectedFilters.indexOf('size-' + attr.value);
                selectedFilters.splice(filterPosition, 1);
                inditex.setSessionStorage('imCategoryFilters', JSON.stringify(selectedFilters));
                imEventServiceWrapper.sendBasicAnalytics('catalogo', 'parrilla', 'limpiar_filtro', 'size-' + attr.value);
            } else if (filterTypes[attr.type] === 'order') {
                selectedFilters.splice(filterPosition, 1);
                inditex.setSessionStorage('imCategoryFilters', JSON.stringify(selectedFilters));
                imEventServiceWrapper.sendBasicAnalytics('catalogo', 'parrilla', 'limpiar_filtro', 'order-' + attr.value);
            }
        }

        function deleteSize(array) {
            array = array || {};
            var keys = Object.keys(array);
            if (keys.length > 0) {
                createEvent('limpiar_filtro', 'size');
                /*for (var i = 0; i < keys.length; i++) {
                    imEventServiceWrapper.sendBasicAnalytics('catalogo', 'parrilla', 'limpiar_filtro', keys[i]);
                }*/
            }
        }

        function deleteOrder(value) {
            if (value) {
                createEvent('limpiar_filtro', 'order');
            }
        }

        function deletePrice(obj) {
            obj = obj || {};
            if (obj.minStep !== obj.min || obj.maxStep !== obj.max) {
                createEvent('limpiar_filtro', 'price');
            }
        }

        function deleteColor(array) {
            array = array || [];
            var selectedFilters = JSON.parse(inditex.getSessionStorage('imCategoryFilters')) || [];
            array.forEach(function (item) {
                var filterPosition = selectedFilters.indexOf(item.value);
                if (item.selected === true && filterPosition > -1) {
                    selectedFilters.splice(filterPosition, 1);
                    inditex.setSessionStorage('imCategoryFilters', JSON.stringify(selectedFilters));
                    createEventData('limpiar_filtro', 'color-' + item.value, 'color');
                }
            });
        }

        function deleteAllAttr(array) {
            array = array || [];
            var keys = Object.keys(array);
            var selectedFilters = JSON.parse(inditex.getSessionStorage('imCategoryFilters')) || [];
            for (var i = 0; i < keys.length; i++) {
                array[keys[i]].forEach(function (item) {
                    var filterPosition = selectedFilters.indexOf(item.value);
                    if (item.selected === true && filterPosition > -1) {
                        selectedFilters.splice(filterPosition, 1);
                        inditex.setSessionStorage('imCategoryFilters', JSON.stringify(selectedFilters));
                        createEventData('limpiar_filtro', keys[i] + '-' + item.value, keys[i]);
                    }
                });
            }
        }

        function applyOrder(value) {
            var selectedFilters = JSON.parse(inditex.getSessionStorage('imCategoryFilters')) || [];
            if (value && selectedFilters.indexOf(value) === -1) {
                if (selectedFilters.indexOf('priceAscending') > -1) {
                    var filterPosition = selectedFilters.indexOf('priceAscending');
                    selectedFilters.splice(filterPosition, 1);
                } else if (selectedFilters.indexOf('priceDescending') > -1) {
                    var filterPosition = selectedFilters.indexOf('priceDescending');
                    selectedFilters.splice(filterPosition, 1);
                }
                selectedFilters.push(value);
                inditex.setSessionStorage('imCategoryFilters', JSON.stringify(selectedFilters));
                createEventData('ordenar_por', 'order-' + value, value);
            } else if (value === '') {
                if (selectedFilters.indexOf('priceAscending') > -1) {
                    value = 'priceAscending';
                    var filterPosition = selectedFilters.indexOf('priceAscending');
                    selectedFilters.splice(filterPosition, 1);
                    inditex.setSessionStorage('imCategoryFilters', JSON.stringify(selectedFilters));
                } else if (selectedFilters.indexOf('priceDescending') > -1) {
                    value = 'priceDescending';
                    var filterPosition = selectedFilters.indexOf('priceDescending');
                    selectedFilters.splice(filterPosition, 1);
                    inditex.setSessionStorage('imCategoryFilters', JSON.stringify(selectedFilters));
                }
                createEventData('limpiar_filtro', 'order-' + value, value);
            }
        }

        function applyAllAttr(array) {
            array = array || [];
            var keys = Object.keys(array);
            var selectedFilters = JSON.parse(inditex.getSessionStorage('imCategoryFilters')) || [];
            for (var i = 0; i < keys.length; i++) {
                array[keys[i]].forEach(function (item) {
                    var filterPosition = selectedFilters.indexOf(item.value);
                    if (item.selected === true && filterPosition === -1) {
                        selectedFilters.push(item.value);
                        inditex.setSessionStorage('imCategoryFilters', JSON.stringify(selectedFilters));
                        createEventData('aplicar_filtro', keys[i] + '-' + item.value, keys[i]);
                    } else if ((item.selected === undefined || item.selected === false) && filterPosition > -1) {
                        selectedFilters.splice(filterPosition, 1);
                        inditex.setSessionStorage('imCategoryFilters', JSON.stringify(selectedFilters));
                        createEventData('limpiar_filtro', keys[i] + '-' + item.value, keys[i]);
                    }
                });
            }
        }

        function applyColor(array) {
            array = array || [];
            var selectedFilters = JSON.parse(inditex.getSessionStorage('imCategoryFilters')) || [];
            array.forEach(function (item) {
                var filterPosition = selectedFilters.indexOf(item.value);
                if (item.selected === true && filterPosition === -1) {
                    selectedFilters.push(item.value);
                    inditex.setSessionStorage('imCategoryFilters', JSON.stringify(selectedFilters));
                    createEventData('aplicar_filtro', 'color-' + item.value, 'color');
                } else if ((item.selected === undefined || item.selected === false) && filterPosition > -1) {
                    selectedFilters.splice(filterPosition, 1);
                    inditex.setSessionStorage('imCategoryFilters', JSON.stringify(selectedFilters));
                    createEventData('limpiar_filtro', 'color-' + item.value, 'color');
                }
            });
        }

        function applyPrice(obj) {
            obj = obj || {};
            if (obj.minStep !== obj.min) {
                createEventData('aplicar_filtro', 'price-minPrice', 'price');
            }
            if (obj.maxStep !== obj.max) {
                createEventData('aplicar_filtro', 'price-maxPrice', 'price');
            }
        }

        function applySize(array) {
            array = array || [];
            var selectedFilters = JSON.parse(inditex.getSessionStorage('imCategoryFilters')) || [];
            array.forEach(function (item) {
                var filterPosition = selectedFilters.indexOf('size-' + item);
                if (filterPosition === -1) {
                    selectedFilters.push('size-' + item);
                    inditex.setSessionStorage('imCategoryFilters', JSON.stringify(selectedFilters));
                    createEventData('aplicar_filtro', 'size-' + item, 'size');
                }
            });
            selectedFilters.slice(0).forEach(function (filter) {
                if (filter.startsWith('size-')) {
                    var cleanSize = filter.replace('size-', '');
                    var filterPosition = array.indexOf(cleanSize);
                    var filterSelectedPosition = selectedFilters.indexOf(filter);
                    if (filterPosition === -1) {
                        selectedFilters.splice(filterSelectedPosition, 1);
                        inditex.setSessionStorage('imCategoryFilters', JSON.stringify(selectedFilters));
                        createEventData('limpiar_filtro', filter, 'size');
                    }
                }
            });
        }

        //Private functions
        function createEventData(action, label, extra) {
            var eventData = {
                cf: 'catalogo',
                category: 'parrilla',
                action: action,
                label: label
            };
            var cat = {
                category: {
                    filter: action === 'aplicar_filtro' ? extra : undefined,
                    sortType: action === 'ordenar_por' ? extra : undefined,
                    viewType: action === 'cambio_vista' ? extra : undefined
                }
            };
            imEventServiceWrapper.sendCustomAnalytics(eventData, cat);
        }
    }
})();

(function () {
    'use strict';

    angular.module('imAnalytics').service('imCommonService', ['PRODUCT', 'PRODUCTS', 'IMPRESSION', imCommonService]);

    function imCommonService(PRODUCT, PRODUCTS, IMPRESSION) {
        function deepmerge(target, src) {
            var array = Array.isArray(src);
            var dst = (array && []) || {};

            if (array) {
                target = target || [];
                dst = dst.concat(target);
                src.forEach(function (e, i) {
                    if (typeof dst[i] === 'undefined') {
                        dst[i] = e;
                    } else if (typeof e === 'object') {
                        dst[i] = deepmerge(target[i], e);
                    } else {
                        if (target.indexOf(e) === -1) {
                            dst.push(e);
                        }
                    }
                });
            } else {
                if (target && typeof target === 'object') {
                    Object.keys(target).forEach(function (key) {
                        dst[key] = target[key];
                    });
                }
                Object.keys(src).forEach(function (key) {
                    if (typeof src[key] !== 'object' || !src[key]) {
                        dst[key] = src[key];
                    } else {
                        if (!target[key]) {
                            dst[key] = src[key];
                        } else {
                            dst[key] = deepmerge(target[key], src[key]);
                        }
                    }
                });
            }

            return dst;
        }

        function replaceValue(oldValue, newValue) {
            return newValue ? newValue : oldValue;
        }

        function replaceProduct(oldArray, newArray) {
            if (newArray) {
                oldArray = newArray.map(function (element) {
                    return deepmerge(PRODUCT, element);
                });
            } else {
                oldArray = [];
            }

            return oldArray;
        }

        function replaceProducts(oldArray, newArray) {
            if (newArray) {
                oldArray = newArray.map(function (element) {
                    return deepmerge(PRODUCTS, element);
                });
            } else {
                oldArray = [];
            }

            return oldArray;
        }

        function replaceImpression(oldArray, newArray) {
            if (newArray) {
                oldArray = newArray.map(function (element) {
                    return deepmerge(IMPRESSION, element);
                });
            } else {
                oldArray = [];
            }

            return oldArray;
        }

        return {
            replaceValue: replaceValue,
            replaceProducts: replaceProducts,
            replaceProduct: replaceProduct,
            deepmerge: deepmerge,
            replaceImpression: replaceImpression
        };
    }
})();

(function () {
    'use strict';

    angular.module('imAnalytics').service('imScrollEvent', ['$timeout', 'imEventService', 'imObjectData', 'imDataService', imScrollEvent]);

    function imScrollEvent($timeout, imEventService, imObjectData, imDataService) {
        function sendEvent(isFinalPage) {
            if (isFinalPage && window.imAnalytics.href !== document.location.href) {
                window.imAnalytics.href = document.location.href;
                var section = 'parrilla';
                if (inditex.iPage === 'ItxCategoryPage' && document.getElementById('lookbook')) {
                    section = 'lookbook';
                } else if (imDataService.isSearch()) {
                    section = 'buscador';
                }
                var dataObject = {
                    eventData: imObjectData.getEventData('navegacion', section, 'final_pagina')
                };

                imEventService.analyticsEvent([dataObject]);
            }
        }

        function activeScroll(scope) {
            //element para cuando se usa en el buscador
            /*scope.$on('scrollstop', function () {
                var finalPageSize = 0;
                var isFinalPage = false;
                finalPageSize = window.innerHeight + window.scrollY;
                $timeout(function () {
                    isFinalPage = finalPageSize >= document.body.offsetHeight;
                    sendEvent(isFinalPage);
                }, 1000);

            });*/
        }

        return {
            activeScroll: activeScroll,
            sendEvent: sendEvent
        };
    }
})();

(function () {
    'use strict';
    // TODO: Move this to directive file
    angular.module('imAnalytics').directive('imFinalPage', ['$timeout', 'imScrollEvent', imFinalPage]);
    function imFinalPage($timeout, imScrollEvent) {
        function link(scope, element) {
            /*
            scope.$on('scrollstop', function () {
                if ((element[0].scrollHeight !== 0) && (element[0].offsetHeight !== 0)) {
                    var finalPageSize = 0;
                    var isFinalPage = false;
                    finalPageSize = element[0].scrollTop + element[0].offsetHeight;
                    $timeout(function () {
                        isFinalPage = finalPageSize >= element[0].scrollHeight;
                        imScrollEvent.sendEvent(isFinalPage);
                    }, 1000);
                }
            });*/
        }

        return {
            link: link
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('imAnalytics')
        .service('imLookbookService', ['imDataService', 'imEventService', 'imObjectData', 'imImpressionService', imLookbookService]);

    function imLookbookService(imDataService, imEventService, imObjectData, imImpressionService) {
        function createLookbookView() {
            imImpressionService.resendPageview();
        }

        function sendView(dataObject) {
            imEventService.pageView(dataObject);
        }

        function createLookView(lookRef, bundleProducts, bundleId) {
            var dataObject = {
                //category: imObjectData.getCategoryData(),
                //product: imObjectData.getProductData(),
                look: imObjectData.getLookData(lookRef),
                context: imObjectData.getContextData(),
                page: imObjectData.getPageData(null, 'catalogo', 'ficha_look', inditex.iCategoryJSON.nameEn.concat('-', lookRef, '/detalles_look')),
                cart: getKeyData(bundleProducts),
                user: imObjectData.getUserBase()
            };
            window.sessionStorage.setItem('lookRef', lookRef);
            window.imAnalytics.bundleId = bundleId;
            sendView([dataObject]);
        }

        function eventSelectLook(lookRef) {
            var dataObject = {
                eventData: imObjectData.getEventData('catalogo', 'lookbook', 'ver_look', lookRef),
                customData: {
                    look: imObjectData.getLookData(lookRef)
                }
            };
            sendEvent([dataObject]);
        }

        function sendEvent(eventData) {
            imEventService.analyticsEvent(eventData);
        }

        //Private
        function getKeyData(cartItems) {
            var cartObject;

            if (Array.isArray(cartItems)) {
                cartObject = {
                    cartProducts: getCartProducts(cartItems)
                };
            } else {
                cartObject = {
                    cartProducts: undefined
                };
            }

            return cartObject;
        }

        function getCartProducts(items) {
            var products = [];
            for (var i = 0, len = items.length; i < len; i++) {
                products.push({
                    key: items[i].id
                });
            }
            return products;
        }

        return {
            createLookView: createLookView,
            createLookbookView: createLookbookView,
            eventSelectLook: eventSelectLook
        };
    }
})();

(function () {
    'use strict';
    angular.module('imAnalytics').service('imSubHomeService', ['imEventService', 'imObjectData', imSubHomeService]);

    function imSubHomeService(imEventService, imObjectData) {
        function sendView(dataObject) {
            imEventService.pageView(dataObject);
        }

        function createView() {
            var dataObject = {
                context: imObjectData.getContextData(),
                user: imObjectData.getUserBase(),
                category: imObjectData.getCategoryPath(),
                page: imObjectData.getPageData(null, 'catalogo', 'subhome', '')
            };
            sendView([dataObject]);
        }

        return {
            createView: createView
        };
    }
})();

(function () {
    'use strict';
    angular.module('imAnalytics').service('imNewsletter', ['imEventService', 'imEventServiceWrapper', 'imObjectData', imNewsletter]);

    function imNewsletter(imEventService, imEventServiceWrapper, imObjectData) {
        var category = 'newsletter';

        function sendView(dataObject) {
            imEventService.pageView(dataObject);
        }

        function createServerError(form, error, place) {
            place ? (category = place) : category;
            imEventServiceWrapper.sendServerError('newsletter', category, form, error);
        }
        function createFormError(form, place) {
            place ? (category = place) : category;
            imEventServiceWrapper.sendFormError('newsletter', category, form);
        }
        function sendOK(action, types, place) {
            place ? (category = place) : category;
            imEventServiceWrapper.sendBasicAnalytics('newsletter', category, action + '_newsletter_ok', types);
        }

        function createView() {
            var dataObject = {
                context: imObjectData.getContextData(),
                user: imObjectData.getUserBase(),
                page: imObjectData.getPageData(null, 'corporativo', 'newsletter', '')
            };
            sendView([dataObject]);
        }
        return {
            createView: createView,
            createServerError: createServerError,
            createFormError: createFormError,
            sendOK: sendOK
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('imAnalytics')
        .service('imWishlistService', ['imEventService', 'imObjectData', 'imProductDataService', 'imDataService', imWishlistService]);

    function imWishlistService(imEventService, imObjectData, imProductDataService, imDataService) {
        return {
            createView: createView,
            createEventAddToWishlist: createEventAddToWishlist,
            createEventRemoveFromWishlist: createEventRemoveFromWishlist,
            createEventRemoveWishlist: createEventRemoveWishlist
        };

        function createView() {
            var dataObject = {
                context: imObjectData.getContextData(),
                user: imObjectData.getUserBase()
            };

            imEventService.pageView([dataObject]);
        }
        function getEventCategory() {
            var type = imDataService.whereAre();
            switch (type) {
                case 'category_page':
                    return 'parrilla';
                    break;
                case 'vista_rapida_producto_category_page':
                    return 'vista_rapida_producto';
                    break;
                case 'product_page':
                    return 'ficha_producto';
                    break;
                case 'vista_rapida_producto_product_page':
                    //Ahora, en la ficha de producto las vistas rápidas son de relacionados.
                    return 'vista_rapida_producto_cross';
                    break;
                case 'bundle_page':
                    return 'ficha_bundle';
                    break;
                case 'vista_rapida_producto_bundle_page':
                    return 'vista_rapida_bundle';
                    break;
                case 'search_page':
                    return 'buscador';
                    break;
                case 'lookbook_page':
                    return 'ficha_look';
                    break;
                case 'vista_rapida_producto_lookbook_page':
                    return 'lookbook_vista_rapida_producto';
                    break;
                case 'shop_cart_page':
                    return 'cesta';
                    break;
                case 'vista_rapida_producto_shop_cart_page':
                    return 'cesta_vista_rapida_producto';
                    break;
                default:
                    return 'ficha_producto';
                    break;
            }
        }

        function getPartNumber(cat, product) {
            if (cat === 'ficha_look' || cat === 'lookbook_vista_rapida_producto') {
                var lookRef = inditex.getSessionStorage('lookRef');
                return lookRef + '-' + product.partNumberColor;
            }
            if (cat === 'ficha_bundle' || cat === 'vista_rapida_bundle') {
                var bundleRef = inditex.getSessionStorage('bundleRef');
                return bundleRef + '-' + product.partNumberColor;
            }

            return product.partNumberColor;
        }

        function getDataLook(cat) {
            var lookRef;
            var bundleRef;
            if (cat === 'ficha_look' || cat === 'lookbook_vista_rapida_producto') {
                lookRef = inditex.getSessionStorage('lookRef');
            }
            if (cat === 'ficha_bundle' || cat === 'vista_rapida_bundle') {
                bundleRef = inditex.getSessionStorage('bundleRef');
            }
            return {
                lookReference: lookRef,
                bundleReference: bundleRef
            };
        }

        function createEventAddToWishlist(product) {
            imProductDataService.getProductInfo(product).then(function (product) {
                var category = getEventCategory();
                var dataObject = {
                    eventData: imObjectData.getEventData('wishlist', category, 'anadir_producto_wishlist', getPartNumber(category, product)),
                    customData: {
                        product: {
                            reference: product.id
                        },
                        look: getDataLook(category)
                    }
                };
                imEventService.analyticsEvent([dataObject]);
            });
        }

        function createEventRemoveFromWishlist(product) {
            imProductDataService.getProductInfo(product).then(function (product) {
                var category = getEventCategory();
                var dataObject = {
                    eventData: imObjectData.getEventData('wishlist', category, 'eliminar_producto_wishlist', getPartNumber(category, product)),
                    customData: {
                        product: {
                            reference: product.id
                        },
                        look: getDataLook(category)
                    }
                };
                imEventService.analyticsEvent([dataObject]);
            });
        }

        function createEventRemoveWishlist() {
            var category = getEventCategory();

            var dataObject = {
                eventData: imObjectData.getEventData('wishlist', category, 'eliminar_todo')
            };
            imEventService.analyticsEvent([dataObject]);
        }
    }
})();

(function () {
    'use strict';
    angular.module('imAnalytics').service('imHeaderEventService', ['imEventService', 'imObjectData', imHeaderEventService]);

    function imHeaderEventService(imEventService, imObjectData) {
        return {
            createEvent: createEvent
        };

        function createEvent(headerIcon) {
            var dataObject;
            switch (headerIcon) {
                case 'searcher':
                    dataObject = {
                        eventData: imObjectData.getEventData('catalogo', 'header', 'buscar')
                    };
                    break;
                case 'logo':
                    dataObject = {
                        eventData: imObjectData.getEventData('navegacion', 'header', 'logo_DUTTI')
                    };
                    break;
                case 'login':
                    dataObject = {
                        eventData: imObjectData.getEventData('perfil_usuario', 'header', 'iniciar_sesion')
                    };
                    break;
                case 'account':
                    dataObject = {
                        eventData: imObjectData.getEventData('perfil_usuario', 'header', 'ver_cuenta')
                    };
                    break;
                case 'cart':
                    dataObject = {
                        eventData: imObjectData.getEventData('checkout', 'header', 'ir_a_cesta')
                    };
                    break;
                case 'help':
                    dataObject = {
                        eventData: imObjectData.getEventData('ayuda', 'header', 'ver_ayuda')
                    };
                    break;
                case 'orders':
                    dataObject = {
                        eventData: imObjectData.getEventData('perfil_comprador', 'header', 'ver_pedidos')
                    };
                    break;
                case 'guest_orders':
                    dataObject = {
                        eventData: imObjectData.getEventData('perfil_comprador', 'header', 'ver_pedidos_invitado')
                    };
                    break;
                case 'wishlist':
                    dataObject = {
                        eventData: imObjectData.getEventData('perfil_usuario', 'header', 'ver_wishlist')
                    };
                    break;
            }
            if (dataObject) {
                imEventService.analyticsEvent([dataObject]);
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('imAnalytics')
        .service('imHomeService', [
            'imObjectData',
            'imEventServiceWrapper',
            'imEventService',
            'imProductDataService',
            'imCommonService',
            'imDataService',
            'PRODUCT_CLICK',
            'PRODUCT_DETAIL',
            'imProductService',
            imHomeService
        ]);

    function imHomeService(
        imObjectData,
        imEventServiceWrapper,
        imEventService,
        imProductDataService,
        imCommonService,
        imDataService,
        PRODUCT_CLICK,
        PRODUCT_DETAIL,
        imProductService
    ) {
        function getCategoryPathDestino(categoryId) {
            var name = getLabelById(categoryId);
            if (name) {
                return name;
            }
            var categoryJSON = imObjectData.getCategoryJSON(parseInt(categoryId));
            return imObjectData.getCategoryPathHome(categoryJSON).categoryPath;
        }

        function parserLabel(label) {
            label = label || '';
            label = label.replace('@', '');
            label = label.replace(/^bg/i, 'boys & girls');
            return getLabelById(label) || label;
        }

        function getLabelById(id) {
            var staticNames = {
                1831519: 'curalate',
                1769045: 'landing_newsletter',
                1866513: 'landing_tiendas'
            };
            return staticNames[id];
        }
        function checkLabelName(name) {
            name = name || '';
            return name.match(/.+\/.+\/.+/) ? true : false;
        }

        function createEventCms(pageNameCms) {
            var eventData = {
                cf: 'catalogo',
                category: 'home' + imObjectData.getSection(),
                action: 'click_cms',
                label: pageNameCms
            };
            imEventServiceWrapper.sendCustomAnalytics(eventData);
        }

        function createEventCategoryPath(id, name, categoryPath, type, cmp) {
            if (id) {
                categoryPath = getCategoryPathDestino(id) || id;
            }
            var order = '';
            if (categoryPath === '@ItxMassimoDuttiFeelPage' && cmp.conf.isMobile) {
                var position = cmp.order.mobile;
                order = '_' + position;
            }

            if (name === 'menu_cover_category' && cmp === 'desplegable') {
                categoryPath = categoryPath + '|desplegable';
            }

            var clickOnMenu = inditex.getSessionStorage('imClickOnMenu');

            if (clickOnMenu) {
                var eventData = {
                    cf: 'navegacion',
                    category: 'home' + imObjectData.getSection(),
                    action: 'click_categoria',
                    label: categoryPath,
                    debugId: id
                };
                inditex.removeSessionStorage('imClickOnMenu');
            } else {
                var eventData = {
                    cf: 'navegacion',
                    category: 'home' + imObjectData.getSection(),
                    action: 'click_' + name + order,
                    label: categoryPath,
                    debugId: id
                };
                var extraData = {
                    photo: imObjectData.getPhotoData(type)
                };
            }

            imEventServiceWrapper.sendCustomAnalytics(eventData, extraData);
        }

        function createEvent(component, label, linkType) {
            var eventData = {
                cf: 'catalogo',
                category: 'home' + imObjectData.getSection(),
                action: 'click_' + component,
                label: parserLabel(label),
                debugId: id
            };
            var extraData = {
                photo: imObjectData.getPhotoData(linkType)
            };
            imEventServiceWrapper.sendCustomAnalytics(eventData, extraData);
        }

        function createView(section) {
            var pageTitle = 'pagina_inicio' + imObjectData.getSection();
            setTimeout(function () {
                imEventServiceWrapper.sendBasicPageView('entrada', 'home', pageTitle);
            }, 1000);
        }

        function createEventV19(section) {
            var eventData = {
                cf: 'navegacion',
                category: 'home' + imObjectData.getSection(),
                action: 'click_cms',
                label: pageNameCms
            };
            imEventServiceWrapper.sendCustomAnalytics(eventData);
        }

        function createProductEvent(cmp, product) {
            var section = 'home' + imObjectData.getSection();
            if (product.type == 'BundleBean') {
                imProductDataService.getBundleInfo(product).then(function (productInfo) {
                    var refBundle = product.activeDetail.reference;
                    var dataObject = {
                        eventData: {
                            cf: 'catalogo',
                            category: section,
                            action: 'ver_bundle',
                            label: refBundle
                        },
                        customData: {
                            look: imObjectData.getLookData(undefined, refBundle)
                        }
                    };
                    if (cmp === 'ver_vista_rapida_bundle') {
                        dataObject.eventData.action = 'ver_vista_rapida_bundle';
                    }

                    var productObject = parseEcommerceProduct(productInfo);
                    sendEcomerceEvent(PRODUCT_CLICK, dataObject, productObject);
                });
            } else {
                imProductDataService.getProductInfo(product, null, null, null).then(function (infoObject) {
                    var productObject = parseEcommerceProduct([infoObject]);
                    var label = infoObject.partNumberColor;
                    var refBundle;
                    if (imProductService.isPopupHomeBundle() || imDataService.isBundle()) {
                        section = 'vista_rapida_bundle';
                        refBundle = imDataService.getBundleRef();
                        if (refBundle) {
                            label = refBundle + '-' + infoObject.partNumberColor;
                        }
                    }
                    var dataObject = {
                        eventData: {
                            cf: 'catalogo',
                            category: section,
                            action: 'ver_producto',
                            label: label
                        },
                        customData: {
                            product: imObjectData.getProductData(infoObject),
                            category: {
                                season: infoObject.season
                            },
                            look: imObjectData.getLookData(undefined, refBundle)
                        }
                    };
                    sendEcomerceEvent(PRODUCT_CLICK, dataObject, productObject);
                });
            }
        }

        function parseEcommerceProduct(products) {
            products = products || [];
            return products.map(function (infoObject) {
                return {
                    name: infoObject.name,
                    id: infoObject.id,
                    category: infoObject.category,
                    position: undefined,
                    dimension96: infoObject.color || infoObject.dimension96,
                    dimension99: infoObject.dimension99,
                    dimension100: infoObject.dimension100,
                    dimension101: infoObject.dimension101,
                    dimension117: infoObject.dimension117,
                    dimension109: infoObject.section || infoObject.dimension109,
                    dimension111: infoObject.family || infoObject.dimension111,
                    dimension113: infoObject.subfamily || infoObject.dimension113,
                    dimension146: imProductDataService.getLastSearchFromCookies(),
                    price: infoObject.price,
                    partNumberColor: infoObject.partNumberColor,
                    key: infoObject.key,
                    isRelated: infoObject.isRelated,
                    dimension29: infoObject.isCustomizable
                };
            });
        }

        function sendEcomerceEvent(type, dataObject, productObject) {
            var list = imDataService.getList();
            if (type == PRODUCT_CLICK) {
                inditex.setSessionStorage('imList', list);
            }
            var ecomerceObject = type;
            ecomerceObject.ecommerce.currencyCode = imCommonService.replaceValue(
                ecomerceObject.ecommerce.currencyCode,
                imDataService.getCurrencyCode()
            );
            ecomerceObject.ecommerce.click.actionField.list = imCommonService.replaceValue(ecomerceObject.ecommerce.click.actionField.list, list);
            ecomerceObject.ecommerce.click.products = imCommonService.replaceProduct(ecomerceObject.ecommerce.click.products, productObject);
            imEventService.analyticsEvent([dataObject], ecomerceObject);
        }

        function createPopupViewBundle(product) {
            if (product.type == 'BundleBean') {
                imProductDataService.getBundleInfo(product).then(function (productInfo) {
                    var refBundle = product.activeDetail.reference;
                    imDataService.setBundleRef(refBundle);
                    var dataObject = {
                        category: imObjectData.getCategoryPath(),
                        photo: imObjectData.getPhotoData(),
                        page: imObjectData.getPageData(null, 'catalogo', 'vista_rapida_bundle', refBundle + '/detalles_bundle'),
                        context: imObjectData.getContextData(),
                        look: imObjectData.getLookData(undefined, refBundle),
                        user: imObjectData.getUserBase()
                    };
                    var productObject = parseEcommerceProduct(productInfo);
                    var ecommerceObject = PRODUCT_DETAIL;
                    ecommerceObject.ecommerce.currencyCode = imCommonService.replaceValue(
                        ecommerceObject.ecommerce.currencyCode,
                        imDataService.getCurrencyCode()
                    );
                    ecommerceObject.ecommerce.detail.actionField.list = imCommonService.replaceValue(
                        ecommerceObject.ecommerce.detail.actionField.list,
                        undefined
                    );
                    ecommerceObject.ecommerce.detail.products = imCommonService.replaceProducts(
                        ecommerceObject.ecommerce.detail.products,
                        productObject
                    );
                    imEventService.popupView([dataObject], ecommerceObject);
                });
            }
        }

        function selectBundleProduct(product) {
            imProductDataService.getProductInfo(product, null, null, null).then(function (infoObject) {
                var refBundle = imDataService.getBundleRef();
                var eventData = {
                    cf: 'catalogo',
                    category: 'vista_rapida_bundle',
                    action: 'ver_producto_bundle',
                    label: refBundle + '-' + infoObject.partNumberColor
                };
                var customData = {
                    product: imObjectData.getProductData(infoObject),
                    look: imObjectData.getLookData(undefined, refBundle)
                };
                imEventServiceWrapper.sendCustomAnalytics(eventData, customData);
            });
        }

        function eventSelectSize(product, size) {
            imProductDataService.getProductInfo(product, null, null, null).then(function (infoObject) {
                var refBundle = imDataService.getBundleRef();
                infoObject.size = size.mastersSizeId;
                var eventData = {
                    cf: 'catalogo',
                    category: 'vista_rapida_bundle',
                    action: 'seleccionar_talla',
                    label: refBundle + '-' + infoObject.partNumberColor + '-' + 'talla_' + infoObject.size
                };
                var customData = {
                    product: imObjectData.getProductData(infoObject),
                    look: imObjectData.getLookData(undefined, refBundle)
                };
                imEventServiceWrapper.sendCustomAnalytics(eventData, customData);
            });
        }

        return {
            createView: createView,
            getCategoryPathDestino: getCategoryPathDestino,
            createEvent: createEvent,
            createEventCms: createEventCms,
            createEventCategoryPath: createEventCategoryPath,
            createEventV19: createEventV19,
            createProductEvent: createProductEvent,
            createPopupViewBundle: createPopupViewBundle,
            selectBundleProduct: selectBundleProduct,
            eventSelectSize: eventSelectSize
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('imAnalytics')
        .service('imSearchService', [
            'imObjectData',
            'imEventServiceWrapper',
            'imEventService',
            'imProductDataService',
            'imCommonService',
            'imDataService',
            'PRODUCT_CLICK',
            imSearchService
        ]);

    function imSearchService(
        imObjectData,
        imEventServiceWrapper,
        imEventService,
        imProductDataService,
        imCommonService,
        imDataService,
        PRODUCT_CLICK
    ) {
        return {
            createEvent: createEvent,
            createView: createView,
            createClickEvent: createClickEvent,
            createBackEvent: createBackEvent
        };

        function createEvent(searchTerm) {
            var eventData = {
                cf: 'catalogo',
                category: 'buscador',
                action: 'buscar',
                label: searchTerm
            };
            var customData = {
                searchEngine: {
                    searchTerm: searchTerm
                }
            };
            imEventServiceWrapper.sendCustomAnalytics(eventData, customData);
        }

        function createBackEvent() {
            var eventData = {
                cf: 'catalogo',
                category: 'buscador',
                action: 'atras'
            };

            imEventServiceWrapper.sendCustomAnalytics(eventData);
        }

        function getSearchList(data) {
            var origin = (data && data.origin) || 'default';
            var BUSCADOR = 'buscador';
            var BUSCADOR_SUGERIDO = 'buscador_sugerido';
            var BUSCADOR_RELACIONADO = 'buscador_relacionados_';
            var options = {
                default: BUSCADOR,
                discovery_wall: BUSCADOR_RELACIONADO + 'discovery_wall',
                empathize_category: BUSCADOR_SUGERIDO,
                empathize_term: BUSCADOR_SUGERIDO,
                history: BUSCADOR_SUGERIDO,
                next_query: BUSCADOR_SUGERIDO,
                next_query_grid: BUSCADOR_SUGERIDO,
                linked: BUSCADOR_SUGERIDO,
                partial: BUSCADOR_SUGERIDO,
                related_tag: BUSCADOR_SUGERIDO,
                spellcheck: BUSCADOR_SUGERIDO,
                no_results: BUSCADOR_RELACIONADO + 'no_results',
                empty_search: BUSCADOR_RELACIONADO + 'empty_search',
                empathize_recommendation: BUSCADOR_SUGERIDO,
                empathize_trending: BUSCADOR_SUGERIDO,
                empathize_next_queries: BUSCADOR_SUGERIDO
            };
            return options[origin] || BUSCADOR;
        }

        function createClickEvent(data) {
            var colbenson = true;
            var list = getSearchList(data);
            var productId = data.productId;
            if (productId) {
                //Colbenson estaba devolviendo un ID concatenado con el color (8639703-505)
                productId = productId.split('-')[0];
            }
            inditex.setSessionStorage('imList', list);
            imProductDataService.getProductInfo(productId, null, null, null, colbenson).then(function (infoObject) {
                var productObject = {
                    name: infoObject.name,
                    id: infoObject.id,
                    category: infoObject.category,
                    position: typeof position !== 'undefined' ? parseInt(position) + 1 : undefined,
                    dimension96: infoObject.color || infoObject.dimension96,
                    dimension99: infoObject.dimension99,
                    dimension100: infoObject.dimension100,
                    dimension101: infoObject.dimension101,
                    dimension117: infoObject.dimension117,
                    dimension109: infoObject.section || infoObject.dimension109,
                    dimension111: infoObject.family || infoObject.dimension111,
                    dimension113: infoObject.subfamily || infoObject.dimension113,
                    dimension146: imProductDataService.getLastSearchFromCookies(),
                    price: infoObject.price,
                    partNumberColor: infoObject.partNumberColor,
                    key: infoObject.key,
                    isRelated: infoObject.isRelated,
                    dimension29: infoObject.isCustomizable
                };

                var list = inditex.getSessionStorage('imList');
                var action;
                var product = imObjectData.getProductData(infoObject);

                if (list.indexOf('buscador_relacionados') > -1) {
                    action = 'ver_producto_cross';
                } else {
                    action = 'ver_producto';
                }

                var eventData = {
                    cf: 'catalogo',
                    category: 'buscador',
                    action: action,
                    label: productObject.partNumberColor
                };

                var customData = {
                    product: product,
                    photo: imObjectData.getPhotoData('foto')
                };

                var dataObject = {
                    eventData: eventData,
                    customData: customData
                };
                var ecomerceObject = PRODUCT_CLICK;

                ecomerceObject.ecommerce.currencyCode = imCommonService.replaceValue(
                    ecomerceObject.ecommerce.currencyCode,
                    imDataService.getCurrencyCode()
                );
                ecomerceObject.ecommerce.click.actionField.list = imCommonService.replaceValue(ecomerceObject.ecommerce.click.actionField.list, list);
                ecomerceObject.ecommerce.click.products = imCommonService.replaceProduct(ecomerceObject.ecommerce.click.products, [productObject]);
                imEventService.analyticsEvent([dataObject], ecomerceObject);
            });
        }

        function createView(searchTerm, totalHits) {
            var dataObject = {};
            searchTerm = searchTerm || window.imAnalytics.imSearchTerm;
            var pageTitle = searchTerm ? 'resultados/lista?q=' + searchTerm : 'resultados/lista';
            dataObject = {
                page: imObjectData.getPageData(null, 'catalogo', 'buscador', pageTitle),
                user: imObjectData.getUserData(),
                context: imObjectData.getContextData(),
                searchEngine: imObjectData.getSearchData(searchTerm, totalHits)
            };
            imEventService.pageView([dataObject]);
        }
    }
})();

(function () {
    'use strict';
    angular.module('imAnalytics').service('imCRMService', ['imObjectData', 'imEventServiceWrapper', 'imEventService', imCRMService]);

    function imCRMService(imObjectData, imEventServiceWrapper, imEventService) {
        var savedPageview;

        return {
            sendPV: sendPV,
            sendPopupPV: sendPopupPV,
            resendSavedPV: resendSavedPV,
            sendGoToConditionsEvent: sendGoToConditionsEvent,
            sendActivateEvent: sendActivateEvent,
            sendDeregisterEvent: sendDeregisterEvent,
            sendOpenDeregisterPopUpEvent: sendOpenDeregisterPopUpEvent,
            sendShowPopup: sendShowPopup,
            sendFeelJoin: sendFeelJoin
        };

        function sendPV(pageType, pageTitle) {
            var dataObject = {
                page: imObjectData.getPageData(null, getPVSection(inditex.iPage), pageType, pageTitle),
                user: imObjectData.getUserData(),
                context: imObjectData.getContextData()
            };

            imEventService.pageView([dataObject]);
        }

        function getLastDataLayerPageview() {
            for (var i = dataLayer.length - 1; i >= 0; i--) {
                if (dataLayer[i].event === 'pageview') {
                    return dataLayer[i];
                }
            }
        }

        function saveCurrentPageview() {
            savedPageview = getLastDataLayerPageview();
        }

        function resendSavedPV() {
            if (savedPageview) {
                dataLayer.push(savedPageview);
                savedPageview = undefined;
            }
        }

        function sendPopupPV(pageType, pageTitle) {
            saveCurrentPageview();

            sendPV(pageType, pageTitle);
        }

        function sendGoToConditionsEvent() {
            sendCRMEvent('unir_programa');
        }

        function sendActivateEvent() {
            sendCRMEvent('alta_fidelizacion_ok');
        }
        function sendOpenDeregisterPopUpEvent() {
            sendCRMEvent('baja_fidelizacion');
        }

        function sendDeregisterEvent() {
            sendCRMEvent('baja_fidelizacion_ok');
        }

        function sendShowPopup() {
            sendCRMEvent('mostrar_popup');
        }

        function sendFeelJoin() {
            var eventData = {
                cf: 'perfil_usuario',
                category: 'fidelizacion',
                action: 'click_unete'
            };

            imEventServiceWrapper.sendCustomAnalytics(eventData);
        }

        function sendCRMEvent(action) {
            var eventData = {
                cf: getEventCF(inditex.iPage),
                category: 'fidelizacion',
                action: action
            };

            imEventServiceWrapper.sendCustomAnalytics(eventData);
        }

        function getPVSection(pageIdentifier) {
            var page2sectionMap = {
                ItxMassimoDuttiFeelPage: 'corporativo',
                ItxMyAccountPage: 'perfil_usuario'
            };

            return page2sectionMap[pageIdentifier] || 'corporativo';
        }

        function getEventCF(pageIdentifier) {
            var page2cfMap = {
                ItxMassimoDuttiFeelPage: 'newsletter',
                ItxMyAccountPage: 'perfil_usuario'
            };

            return page2cfMap[pageIdentifier] || 'corporativo';
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('imAnalytics')
        .service('imLookbookCmsService', [
            'imObjectData',
            'imProductDataService',
            'imEventService',
            'imDataService',
            'imCommonService',
            'PRODUCT_CLICK',
            'PRODUCT_DETAIL',
            'imProductService',
            imLookbookCmsService
        ]);

    function imLookbookCmsService(
        imObjectData,
        imProductDataService,
        imEventService,
        imDataService,
        imCommonService,
        PRODUCT_CLICK,
        PRODUCT_DETAIL,
        imProductService
    ) {
        return {
            sendPageviewLookbook: sendPageviewLookbook,
            createProductEvent: createProductEvent,
            createPopupViewBundle: createPopupViewBundle
        };

        function createProductEvent(cmp, product) {
            var section = 'catalogo';
            if (product.type == 'BundleBean') {
                imProductDataService.getBundleInfo(product).then(function (productInfo) {
                    var refBundle = product.activeDetail.reference;
                    var dataObject = {
                        eventData: {
                            cf: 'catalogo',
                            category: section,
                            action: 'ver_bundle',
                            label: refBundle
                        },
                        customData: {
                            look: imObjectData.getLookData(undefined, refBundle)
                        }
                    };
                    if (cmp === 'ver_vista_rapida_bundle') {
                        dataObject.eventData.action = 'ver_vista_rapida_bundle';
                    }

                    var productObject = parseEcommerceProduct(productInfo);
                    sendEcomerceEvent(PRODUCT_CLICK, dataObject, productObject);
                });
            } else {
                imProductDataService.getProductInfo(product, null, null, null).then(function (infoObject) {
                    var productObject = parseEcommerceProduct([infoObject]);
                    var label = infoObject.partNumberColor;
                    var refBundle;
                    if (imProductService.isPopupHomeBundle() || imDataService.isBundle()) {
                        section = 'vista_rapida_bundle';
                        refBundle = imDataService.getBundleRef();
                        if (refBundle) {
                            label = refBundle + '-' + infoObject.partNumberColor;
                        }
                    }
                    var dataObject = {
                        eventData: {
                            cf: 'catalogo',
                            category: section,
                            action: 'ver_producto',
                            label: label
                        },
                        customData: {
                            product: imObjectData.getProductData(infoObject),
                            category: {
                                season: infoObject.season
                            },
                            look: imObjectData.getLookData(undefined, refBundle)
                        }
                    };
                    sendEcomerceEvent(PRODUCT_CLICK, dataObject, productObject);
                });
            }
        }

        function sendEcomerceEvent(type, dataObject, productObject) {
            var list = imDataService.getList();
            if (type == PRODUCT_CLICK) {
                inditex.setSessionStorage('imList', list);
            }
            var ecomerceObject = type;
            ecomerceObject.ecommerce.currencyCode = imCommonService.replaceValue(
                ecomerceObject.ecommerce.currencyCode,
                imDataService.getCurrencyCode()
            );
            ecomerceObject.ecommerce.click.actionField.list = imCommonService.replaceValue(ecomerceObject.ecommerce.click.actionField.list, list);
            ecomerceObject.ecommerce.click.products = imCommonService.replaceProduct(ecomerceObject.ecommerce.click.products, productObject);
            imEventService.analyticsEvent([dataObject], ecomerceObject);
        }

        function parseEcommerceProduct(products) {
            products = products || [];
            return products.map(function (infoObject) {
                return {
                    name: infoObject.name,
                    id: infoObject.id,
                    category: infoObject.category,
                    position: undefined,
                    dimension96: infoObject.color || infoObject.dimension96,
                    dimension99: infoObject.dimension99,
                    dimension100: infoObject.dimension100,
                    dimension101: infoObject.dimension101,
                    dimension117: infoObject.dimension117,
                    dimension109: infoObject.section || infoObject.dimension109,
                    dimension111: infoObject.family || infoObject.dimension111,
                    dimension113: infoObject.subfamily || infoObject.dimension113,
                    dimension146: imProductDataService.getLastSearchFromCookies(),
                    price: infoObject.price,
                    partNumberColor: infoObject.partNumberColor,
                    key: infoObject.key,
                    isRelated: infoObject.isRelated,
                    dimension29: infoObject.isCustomizable
                };
            });
        }

        function createPopupViewBundle(product) {
            imProductDataService.getBundleInfo(product).then(function (productInfo) {
                var refBundle = product.detail.reference;
                imDataService.setBundleRef(refBundle);
                var dataObject = {
                    category: imObjectData.getCategoryPath(),
                    photo: imObjectData.getPhotoData(),
                    page: imObjectData.getPageData(null, 'catalogo', 'vista_rapida_bundle', refBundle + '/detalles_bundle'),
                    context: imObjectData.getContextData(),
                    look: imObjectData.getLookData(undefined, refBundle),
                    user: imObjectData.getUserBase()
                };
                var productObject = parseEcommerceProduct(productInfo);
                var ecommerceObject = PRODUCT_DETAIL;
                ecommerceObject.ecommerce.currencyCode = imCommonService.replaceValue(
                    ecommerceObject.ecommerce.currencyCode,
                    imDataService.getCurrencyCode()
                );
                ecommerceObject.ecommerce.detail.actionField.list = imCommonService.replaceValue(
                    ecommerceObject.ecommerce.detail.actionField.list,
                    undefined
                );
                ecommerceObject.ecommerce.detail.products = imCommonService.replaceProducts(ecommerceObject.ecommerce.detail.products, productObject);
                imEventService.popupView([dataObject], ecommerceObject);
            });
        }

        function sendPageviewLookbook() {
            var categoryName = inditex.iCategoryJSON && inditex.iCategoryJSON.nameEn;
            var section = 'catalogo';
            var pageType = 'lookbook';
            var pageTitle = categoryName + '/parrilla_looks';
            var category = imObjectData.getCategoryPath();

            var dataObject = {
                category: category,
                page: imObjectData.getPageData(null, section, pageType, pageTitle),
                user: imObjectData.getUserData(),
                context: imObjectData.getContextData()
            };
            imEventService.pageView([dataObject]);
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('imAnalytics')
        .service('imMicrositeService', [
            'imObjectData',
            'imProductDataService',
            'imEventService',
            'imDataService',
            'imCommonService',
            'PRODUCT_CLICK',
            'PRODUCT_DETAIL',
            imMicrositeService
        ]);

    function imMicrositeService(imObjectData, imProductDataService, imEventService, imDataService, imCommonService, PRODUCT_CLICK, PRODUCT_DETAIL) {
        return {
            sendPageview: sendPageview,
            createPopupViewBundle: createPopupViewBundle,
            createProductEvent: createProductEvent
        };

        function createProductEvent(product) {
            imProductDataService.getBundleInfo(product).then(function (productInfo) {
                var refBundle = product.detail.reference;
                imDataService.setBundleRef(refBundle);
                var dataObject = {
                    eventData: {
                        cf: 'catalogo',
                        category: 'microsite',
                        action: 'ver_vista_rapida_bundle',
                        label: refBundle
                    },
                    customData: {
                        look: imObjectData.getLookData(undefined, refBundle)
                    }
                };
                var productObject = parseEcommerceProduct(productInfo);
                sendEcomerceEvent(PRODUCT_CLICK, dataObject, productObject);
            });
        }

        function createPopupViewBundle(product) {
            imProductDataService.getBundleInfo(product).then(function (productInfo) {
                var refBundle = product.detail.reference;
                imDataService.setBundleRef(refBundle);
                var dataObject = {
                    category: imObjectData.getCategoryPath(),
                    photo: imObjectData.getPhotoData(),
                    page: imObjectData.getPageData(null, 'catalogo', 'vista_rapida_bundle', refBundle + '/detalles_bundle'),
                    context: imObjectData.getContextData(),
                    look: imObjectData.getLookData(undefined, refBundle),
                    user: imObjectData.getUserBase()
                };
                var productObject = parseEcommerceProduct(productInfo);
                var ecommerceObject = PRODUCT_DETAIL;
                ecommerceObject.ecommerce.currencyCode = imCommonService.replaceValue(
                    ecommerceObject.ecommerce.currencyCode,
                    imDataService.getCurrencyCode()
                );
                ecommerceObject.ecommerce.detail.actionField.list = imCommonService.replaceValue(
                    ecommerceObject.ecommerce.detail.actionField.list,
                    undefined
                );
                ecommerceObject.ecommerce.detail.products = imCommonService.replaceProducts(ecommerceObject.ecommerce.detail.products, productObject);
                imEventService.popupView([dataObject], ecommerceObject);
            });
        }

        function parseEcommerceProduct(products) {
            products = products || [];
            return products.map(function (infoObject) {
                return {
                    name: infoObject.name,
                    id: infoObject.id,
                    category: infoObject.category,
                    position: undefined,
                    dimension96: infoObject.color || infoObject.dimension96,
                    dimension99: infoObject.dimension99,
                    dimension100: infoObject.dimension100,
                    dimension101: infoObject.dimension101,
                    dimension117: infoObject.dimension117,
                    dimension109: infoObject.section || infoObject.dimension109,
                    dimension111: infoObject.family || infoObject.dimension111,
                    dimension113: infoObject.subfamily || infoObject.dimension113,
                    dimension146: imProductDataService.getLastSearchFromCookies(),
                    price: infoObject.price,
                    partNumberColor: infoObject.partNumberColor,
                    key: infoObject.key,
                    isRelated: infoObject.isRelated,
                    dimension29: infoObject.isCustomizable
                };
            });
        }

        function sendEcomerceEvent(type, dataObject, productObject) {
            var list = imDataService.getList();
            if (type == PRODUCT_CLICK) {
                inditex.setSessionStorage('imList', list);
            }
            var ecomerceObject = type;
            ecomerceObject.ecommerce.currencyCode = imCommonService.replaceValue(
                ecomerceObject.ecommerce.currencyCode,
                imDataService.getCurrencyCode()
            );
            ecomerceObject.ecommerce.click.actionField.list = imCommonService.replaceValue(ecomerceObject.ecommerce.click.actionField.list, list);
            ecomerceObject.ecommerce.click.products = imCommonService.replaceProduct(ecomerceObject.ecommerce.click.products, productObject);
            imEventService.analyticsEvent([dataObject], ecomerceObject);
        }

        function sendPageview(section, pageType, pageTitle) {
            var category = imObjectData.getCategoryPath();
            section = section || 'catalogo';
            pageType = pageType || 'microsite';
            pageTitle = pageTitle || category.categoryPath;

            var dataObject = {
                category: category,
                page: imObjectData.getPageData(null, section, pageType, pageTitle),
                user: imObjectData.getUserData(),
                context: imObjectData.getContextData()
            };
            imEventService.pageView([dataObject]);
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('imAnalytics')
        .service('imStockAvailabilityService', [
            'imEventService',
            'imObjectData',
            'imProductDataService',
            'imEventServiceWrapper',
            'imImpressionService',
            imStockAvailabilityService
        ]);

    function imStockAvailabilityService(imEventService, imObjectData, imProductDataService, imEventServiceWrapper, imImpressionService) {
        return {
            createPopupView: createPopupView,
            createNotificationEvent: createNotificationEvent,
            createServerErrorEvent: createServerErrorEvent,
            createFormErrorEvent: createFormErrorEvent,
            resendPageview: resendPageview
        };

        function createPopupView(product, selectedSize) {
            var color = product.state.selectedColor;
            var size = selectedSize;
            imProductDataService.getProductInfo(product, null, color.id, size.sku).then(function (infoObject) {
                var dataObject = {
                    category: imObjectData.getCategoryPath(),
                    photo: imObjectData.getPhotoData(),
                    page: imObjectData.getPageData(null, 'catalogo', 'ficha_producto', infoObject.partNumber + '/' + size.visibility),
                    context: imObjectData.getContextData(),
                    user: imObjectData.getUserBase(),
                    product: imObjectData.getProductData(infoObject)
                };
                if (dataObject) {
                    dataObject.product.stock = 'no';
                    imEventService.popupView([dataObject]);
                }
            });
        }

        function createNotificationEvent(product, selectedSize) {
            var color = product.state.selectedColor;
            var size = selectedSize;
            imProductDataService.getProductInfo(product, null, color.id, size.sku).then(function (infoObject) {
                var dataObject = {
                    eventData: {
                        cf: 'checkout',
                        category: size.visibility,
                        action: 'crear_notificacion',
                        label: infoObject.partNumber
                    },
                    customData: {
                        product: imObjectData.getProductData(infoObject)
                    }
                };
                imEventService.analyticsEvent([dataObject]);
            });
        }

        function createServerErrorEvent(selectedSize, form, error) {
            imEventServiceWrapper.sendServerError('checkout', selectedSize.visibility, form, error);
        }

        function createFormErrorEvent(selectedSize, form) {
            imEventServiceWrapper.sendFormError('checkout', selectedSize.visibility, form);
        }

        function resendPageview() {
            imImpressionService.resendPageview();
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('imAnalytics')
        .service('imDispatcherService', [
            'DEBUG',
            'imCheckoutService',
            'imEventService',
            'imGridService',
            'imHomeService',
            'imLookbookService',
            'imObjectData',
            'imPopupService',
            'imProductService',
            imDispatcherService
        ]);

    function imDispatcherService(
        DEBUG,
        imCheckoutService,
        imEventService,
        imGridService,
        imHomeService,
        imLookbookService,
        imObjectData,
        imPopupService,
        imProductService
    ) {
        return {
            sortEvent: sortEvent
        };

        function sortEvent(type, product, place, dropdown) {
            if (dropdown === 'minicart' || (dropdown === 'login' && inditex.iUserJSON.email === null) || dropdown === 'search') {
                resendMainPageview();
            } else if (!dropdown) {
                var elementLocation = eventPageLocation(product, place);
                sendToService(type, elementLocation, product);
            }
        }

        function sendToService(type, elementLocation, product) {
            var eventType = {
                pageview: 'pageview',
                event: 'analyticsEvent'
            };
            switch (elementLocation.page) {
                case 'account': {
                    if (eventType[type] === 'pageview') {
                    } else if (eventType[type] === 'analyticsEvent') {
                    } else {
                        DEBUG.message('Unknown event type');
                    }
                    break;
                }
                case 'bundle': {
                    if (eventType[type] === 'pageview') {
                    } else if (eventType[type] === 'analyticsEvent') {
                    } else {
                        DEBUG.message('Unknown event type');
                    }
                    break;
                }
                case 'cart': {
                    if (eventType[type] === 'pageview') {
                        if (elementLocation.relatedPopup) {
                            imPopupService.sendPopupEcommerce(product, product.state.selectedColorIndex);
                        } else if (elementLocation.buyLater) {
                            imCheckoutService.saveForLaterPageview(0);
                        } else {
                            imCheckoutService.createCartShop(inditex.iUserJSON.shopCart, 1);
                        }
                    } else if (eventType[type] === 'analyticsEvent') {
                    } else {
                        DEBUG.message('Unknown event type');
                    }
                    break;
                }
                case 'checkout': {
                    if (eventType[type] === 'pageview') {
                    } else if (eventType[type] === 'analyticsEvent') {
                    } else {
                        DEBUG.message('Unknown event type');
                    }
                    break;
                }
                case 'confirmation': {
                    if (eventType[type] === 'pageview') {
                    } else if (eventType[type] === 'analyticsEvent') {
                    } else {
                        DEBUG.message('Unknown event type');
                    }
                    break;
                }
                case 'error': {
                    if (eventType[type] === 'pageview') {
                    } else if (eventType[type] === 'analyticsEvent') {
                    } else {
                        DEBUG.message('Unknown event type');
                    }
                    break;
                }
                case 'grid': {
                    if (eventType[type] === 'pageview') {
                        imGridService.sendPageView();
                    } else if (eventType[type] === 'analyticsEvent') {
                    } else {
                        DEBUG.message('Unknown event type');
                    }
                    break;
                }
                case 'guest_account': {
                    if (eventType[type] === 'pageview') {
                    } else if (eventType[type] === 'analyticsEvent') {
                    } else {
                        DEBUG.message('Unknown event type');
                    }
                    break;
                }
                case 'home': {
                    if (eventType[type] === 'pageview') {
                        imHomeService.createView();
                    } else if (eventType[type] === 'analyticsEvent') {
                    } else {
                        DEBUG.message('Unknown event type');
                    }
                    break;
                }
                case 'lookbook': {
                    if (eventType[type] === 'pageview') {
                        if (bundles && imLookbookService && bundles[bundleIndex]) {
                            imLookbookService.createLookView(
                                bundles[bundleIndex].detail.reference,
                                bundles[bundleIndex].bundleProductSummaries,
                                bundles[bundleIndex].id
                            );
                        }
                    } else if (eventType[type] === 'analyticsEvent') {
                    } else {
                        DEBUG.message('Unknown event type');
                    }
                    break;
                }
                case 'product': {
                    if (eventType[type] === 'pageview') {
                        if (product && inditex.iProductId === product.id) {
                            if (product.isBundleBean && product.bundleProductSummaries.length) {
                                imProductService.createViewBundle(product, product.state.selectedColorIndex);
                            } else {
                                imProductService.createView(product, product.state.selectedColorIndex);
                            }
                        }
                    } else if (eventType[type] === 'analyticsEvent') {
                    } else {
                        DEBUG.message('Unknown event type');
                    }
                    break;
                }
                case 'repayment': {
                    if (eventType[type] === 'pageview') {
                    } else if (eventType[type] === 'analyticsEvent') {
                    } else {
                        DEBUG.message('Unknown event type');
                    }
                    break;
                }
                case 'searcher': {
                    if (eventType[type] === 'pageview') {
                    } else if (eventType[type] === 'analyticsEvent') {
                    } else {
                        DEBUG.message('Unknown event type');
                    }
                    break;
                }
                case 'worldwide': {
                    if (eventType[type] === 'pageview') {
                    } else if (eventType[type] === 'analyticsEvent') {
                    } else {
                        DEBUG.message('Unknown event type');
                    }
                    break;
                }
            }
        }

        function eventPageLocation(product, place) {
            var pageKind = inditex.iPage;
            pageKind = isLookbook() ? 'ItxLookBookPage' : pageKind;
            pageKind = isSearch() ? 'ItxSearchPage' : pageKind;

            var pageType = {
                Itx410ErrorPage: 'error',
                ItxBundlePage: 'bundle',
                ItxCategoryPage: 'grid',
                ItxCheckoutPage: 'checkout',
                ItxGuestAccountPage: 'guest_account',
                ItxHomePage: 'home',
                ItxHomeBgPage: 'home',
                ItxHomeMenPage: 'home',
                ItxHomeWomenPage: 'home',
                ItxLookBookPage: 'lookbook',
                ItxMyAccountPage: 'account',
                ItxOrderConfirmationPage: 'confirmation',
                ItxOrderRepaymentPage: 'repayment',
                ItxProductPage: 'product',
                ItxSearchPage: 'searcher',
                ItxShopCartPage: 'cart',
                ItxWorldWidePage: 'worldwide'
            };

            var pageLocation = {
                buyLater: isBuyLaterSection(),
                bundle: isBundle(product),
                lookbook: isLookbook(),
                page: pageType[pageKind],
                popup: isProductDialog(),
                relatedPopup: isRelatedProductDialog(product),
                searcher: isSearch()
            };
            return pageLocation;
        }

        function isSearch() {
            return angular.element('.has-search').length > 0 || angular.element('.ebx-empathy-x--opened').length > 0;
        }

        function isProductDialog() {
            return angular.element('.ngdialog.ma-dialog').length > 0;
        }

        function isRelatedProductDialog(product) {
            return angular.element('itx-related-product-dialog').length > 0 || (isProductDialog() && product.isRelated);
        }

        function isLookbook() {
            return document.getElementById('lookbook') ? true : false;
        }

        function isBundle(product) {
            product = product || {};
            return product.gridElemType == 'BUNDLE' ? true : false || angular.element('.ma-product-bundle-container').length > 0;
        }

        function isBuyLaterSection() {
            var cartTab = angular.element('.group-items-tab.active');
            if (cartTab.length > 0 && cartTab.attr('ng-click') && cartTab.attr('ng-click').indexOf('showBuylater') > -1) {
                return true;
            }
            return false;
        }

        function resendMainPageview() {
            var lastPageview = getLastDataLayerPageview();
            var userObject = imObjectData.getUserData();
            if (lastPageview) {
                if (userObject) {
                    lastPageview.user = userObject;
                }
                dataLayer.push(lastPageview);
            }

            function getLastDataLayerPageview() {
                var lastPageviewIndex = getLastPageviewHitIndex();
                for (var i = dataLayer.length - 1; i >= 0; i--) {
                    if (dataLayer[i].event === 'pageview') {
                        if (dataLayer[i].page.pageTitle !== 'login' && dataLayer[i].page.pageType !== 'buscador') {
                            if (
                                dataLayer[i - 1].event !== 'analyticsEvent' ||
                                (dataLayer[i - 1].eventData && dataLayer[i - 1].eventData.action !== 'iniciar_sesion')
                            ) {
                                if (dataLayer[i] !== dataLayer[lastPageviewIndex]) {
                                    return dataLayer[i];
                                }
                            }
                            return;
                        }
                    }
                }
            }

            function getLastPageviewHitIndex() {
                for (var i = dataLayer.length - 1; i >= 0; i--) {
                    if (/pageView|popupview/i.test(dataLayer[i].event)) {
                        return i;
                    }
                }
            }
        }
    }
})();
